
import { functions } from "lodash-es";
import util from "./util";

var unbind = 0;
var unbindMVP = 0;
var unbindReg = 0;
var unbindcarousel = 0;
var unbindreccarousel = 0;
var unbindEinsteinCarousel = 0;
var unbindCompare = 0;
let unbindRecomm = 0;
var currencyCode = window.User.currencyCode;

function isMobile() {
	return $(window).width() <= 640;
}
//Specific for PDP
function getProductName() {
	return $(".product-detail .product-name").html();
}

//Specific for PDP
function getProductBrand() {
	return SitePreferences.PRODUCT_BRAND; //$(".product-detail .product-brand").text();
}
//Specific for PDP
function getProductID() {
	return $("#pid").val();
}
//Specific for PDP
function getProductCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(2)").first().text().trim();
}
//Specific for PDP
function getProductsubCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(3)").first().text().trim();
}
// Specific for PDP
function getProductsubsubCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(4)").first().text().trim();
}
// Specific for PDP
function getProductOrederType() {
	var replen = $(".replenishmentCycle").val();
	if (replen > 0) {
		return "Replenishment"
	} else {
		return "Regular"
	}

}

function listType(){ // Search Results or Product Category List
    return searchItems.search ? 'search result list' : 'product category list';
}

function listName(){ // Search Results or Product Category List
    return searchItems.search ? 'Search' : $(".breadcrumbs-desk-only .breadcrumb").find(".bc-item .breadcrumb-element:last").text().trim();
}

function getProductNamePLP($productTile) {
	return $productTile.find('.product-name').text().trim();
}

function getProductIdPLP($productTile) {
	return $productTile.attr("data-itemid");
}
function getPDPSlectedAccordion($headerElement) {
	var ariaControls = $headerElement.attr('aria-controls');
	var interectionType = ariaControls;
	switch (ariaControls) {
	case 'overview':
		interectionType = 'Details';
		break;
	case 'allingredients':
		interectionType = 'View full Product Ingredient';
		break;	
	}
	return interectionType;
}

function getActiveSortingRule() {
	var httpParams = util.getQueryStringParams(window.location.href);
	var sortParam = httpParams["srule"];

	if (!sortParam) {
		return null;
	}

	return sortParam.split("-").map(function (w) {
		return w[0].toUpperCase() + w.substr(1);
	}).join(" ");
}

function pushToDataLayer(o) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(util.filterObj(o));
	//alert(JSON.stringify(util.filterObj(o)));
}

function isScrolledIntoView(elem) {
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height() - 150;
	var elemTop = $(elem).offset().top;
	var result = [];
	result.push(((elemTop <= docViewBottom) && (elemTop >= docViewTop)));
	if ((elemTop <= docViewBottom) && (elemTop >= docViewTop)) {
		result.push($(elem).parent().attr('class'));
	}
	return result;
}

//page-specific: PLP
function getRefinementsFromURL() {
	var str = "";
	if (window.location.href.split("?").length > 1) {
		var urlparam;
		if (window.location.href.split("?")[1].indexOf("&") > -1) {
			urlparam = window.location.href.split("?")[1].split("&");
			var length = urlparam.length;
			var prefnval, prefnkey, prefvval, prefvkey;
			for (var i = 0; i < length; i++) {
				var prefn = urlparam[i].indexOf("prefn");
				if (prefn > -1) {
					prefnkey = urlparam[i].split("=")[0];
					prefnval = urlparam[i].split("=")[1];
					var num = prefnkey.charAt(5);
					for (var a = 0; a < length; a++) {
						var prefv = urlparam[a].indexOf("prefv");
						prefvkey = urlparam[a].split("=")[0];
						if (prefvkey == "prefv" + num) {
							prefvval = urlparam[a].split("=")[1];
							str += "[" + prefnval + ":" + prefvval + "]";
						}
					}
				}
			}
		}
	}
	return str;
}

function trackConsultationEvent(data) {
	var TOOL_TYPES = {
		"skincareConsultation": "Skincare Consultation"
	};

	pushToDataLayer({
		"event": data.event,
		"pageCategory": "Consultation Tool",
		"consultationToolType": TOOL_TYPES[data.toolname] || data.toolname,
		"consultationQuestion": data.question,
		"consultationResponse": data.answers
	});
}

function trackConsultationPageview(data) {
	pushToDataLayer({
		"event": "consultationSteps",
		"pageCategory": "Consultation Tool",
		"consultationToolType": data.toolname,
		"consultationStep": data.pagename
	});
}

function trackInternalPromotionEvent(data) {

	var promotionURL = data.pageName;

	pushToDataLayer({
		"event": "eePromoClick",
		"pageSubCategory": pageInfo.pageSubCategory,
		"pageCategory": pageInfo.pageCategory,
		'promotions': [{
			"position": data.position,
			"id": data.id,
			"creative": data.creative,
			"name": data.name
		}]
	}), (function () {
		setTimeout(function () {
			if (promotionURL != undefined) {
				document.location = promotionURL;
			}
		}, 1000);
	})();
}

function trackInternalPromotionPageView(data) {
	pushToDataLayer({
		"eeAction": "eePromoView",
		"event": "eePromoView",
		"pageSubCategory": pageInfo.pageSubCategory,
		"pageCategory": pageInfo.pageCategory,
		'promotions': [{
			"position": data.position,
			"id": data.id,
			"creative": data.creative,
			"name": data.name
		}]
	});
}

function gtmCouponApplied(data) {
	// fire when coupon is added after page load.
    if($(".gtpromochecker").length > 0){
        if(!localStorage.getItem('couponvalidation')){
                pushToDataLayer({
                        "productCoupon": ($('.gtpromochecker').last()).data("id"),
                        "event": "couponSubmission",
                        "pageSubCategory": pageInfo.pageSubCategory,
                        "pageCategory": DtpageInfo.pageCategory
                })
                localStorage['couponvalidation'] = true;
          }
    }else if ($(".gtpromochecker").length > 0){
        localStorage['couponvalidation'] = true;
            
    }else{
        localStorage.removeItem('couponvalidation');
    }
}

function reinsurancePDPDatalayer(data, clickedIndex) {
	var reinsuranceType, reinsurancePage;
	reinsuranceType = data.find('.reinsurance-title').html();
	reinsurancePage = "PDP";
	pushToDataLayer({
		'event': 'reinsurance_interaction',
		'reinsurance_type' : reinsuranceType,
		'reinsurance_page' : reinsurancePage,
		'reinsurance_position': clickedIndex + 1
	});
	if($("#reinsurance-panel").length) {
		$("#reinsurance-panel .panel-body .panel-content-buttons").attr({
			"data-reinsurance-type": reinsuranceType,
			"data-reinsurance-page": reinsurancePage,
			"data-reinsurance-position": clickedIndex + 1
		})
	}
}

function reinsuranceCheckoutDatalayer(data, clickedIndex) {
	var reinsuranceType, clickedIndex, reinsurancePage;
	if( $(data).find('.reinsurance-title').hasClass('order-and-payment-title')) {
		reinsuranceType = $(data).find('.reinsurance-title').html() + " " + $(data).find('.reinsurance-subtitle').html();
	} else {
		reinsuranceType = $(data).find('.reinsurance-title').html();
	}
	if (pageInfo.pageSubCategory === 'Cart Page' || window.Resources.PAGE_CATEGORY == 'cart_page') {
		reinsurancePage = 'Cart Page'
	} else if (pageInfo.pageSubCategory === 'Shipping' || window.Resources.PAGE_CATEGORY == 'coshipping-start') {
		reinsurancePage = 'Shipping'
	} else if (pageInfo.pageSubCategory === 'Payment' || window.Resources.PAGE_CATEGORY == 'coshipping-singleshipping') {
		reinsurancePage = 'Payment'
	}
	// if ($(this).find(".reinsurance-wrapper-cart").hasClass('show-description') === true || $(this).hasClass('open-reinsurance-panel')) {
	pushToDataLayer({
		'event': 'reinsurance_interaction',
		'reinsurance_type' : reinsuranceType,
		'reinsurance_page' : reinsurancePage,
		'reinsurance_position': clickedIndex + 1
	});
	// }
	if($("#reinsurance-panel").length) {
		$("#reinsurance-panel .panel-body .panel-content-buttons").attr({
			"data-reinsurance-type": reinsuranceType,
			"data-reinsurance-page": reinsurancePage,
			"data-reinsurance-position": clickedIndex + 1
		})
	}
}

// reassurance data layer new
function reassuranceCheckoutDatalayer(data, clickedIndex) {
	let reassuranceType, reassurancePage;
	
	reassuranceType = $(data).find('.reassurance-content').text().trim();

	if (pageInfo.pageSubCategory === 'Cart Page' || window.Resources.PAGE_CATEGORY == 'cart_page') {
		reassurancePage = 'Cart Page'
	} else if (pageInfo.pageSubCategory === 'Shipping' || window.Resources.PAGE_CATEGORY == 'coshipping-start') {
		reassurancePage = 'Shipping'
	} else if (pageInfo.pageSubCategory === 'Payment' || window.Resources.PAGE_CATEGORY == 'coshipping-singleshipping') {
		reassurancePage = 'Payment'
	}
	pushToDataLayer({
		'event': 'reinsurance_interaction',
		'reinsurance_type' : reassuranceType,
		'reinsurance_page' : reassurancePage,
		'reinsurance_position': clickedIndex + 1
	});

	if($("#reinsurance-panel").length) {
		$("#reinsurance-panel .panel-body .panel-content-buttons").attr({
			"data-reinsurance-type": reassuranceType,
			"data-reinsurance-page": reassurancePage,
			"data-reinsurance-position": clickedIndex + 1
		})
	}
}

/*
 * datalayer for Reinsurance Elements
 */
function reinsuranceElements(data) {	
	var reinsuranceChoice = '';
	
	switch(data) {
	  case 'shipping-reinsurance-popup':
		  reinsuranceChoice = 'Shipping';
	    break;
	  case 'return-refund-reinsurance-popup':
		  reinsuranceChoice = 'Returns';
	    break;
	  case 'order-payment-reinsurance-popup':
		  reinsuranceChoice = 'Orders';
	    break;
	  case 'discount-codes-reinsurance-popup':
		  reinsuranceChoice = 'Offers';
	    break;
	}
	
	pushToDataLayer({
		"page":pageInfo.pageCategory,
		"event": "reinsuranceElements",
		"reinsuranceChoice" : reinsuranceChoice,
		"pageSubCategory": pageInfo.pageSubCategory,
		"pageCategory": pageInfo.pageCategory				
	});	
}

// add product ai dialog PDP
function addProductAIDialogPDP(dialogVariantColor, dialogVariantSize) {
	const addToCartType = "Dialog - Product Page";
	let selectedColor, selectedSize;
	dialogVariantColor == undefined ? selectedColor = sessionStorage.getItem('selectedVariantsColor') : selectedColor = dialogVariantColor;
	dialogVariantSize == undefined ? selectedSize = sessionStorage.getItem('selectedVariantSize') : selectedSize = dialogVariantSize;
	pushToDataLayer({
		"currencyCode": window.Resources.CURRENCY,
		"event": "addToCart",
		"addToCartType": addToCartType,
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		'products': [{
			"id": pdpdata.masterID,
			"listType": pageInfo.pageCategory,
			"listName": $(".breadcrumb").find(".breadcrumb-element:eq(1)").first().text().trim(),
			"category": window.productCache.catid,
			"price": pdpdata.pricing ? pdpdata.pricing.sale ? pdpdata.pricing.sale : pdpdata.pricing.minprice ? pdpdata.pricing.minprice : null : null,
			"name": getProductName(),
			"brand": getProductBrand(),
			"quantity": Number($(".quantity select").val()),
			"size":  selectedSize ? selectedSize : pdpdata.size,
			"subCategory": window.productCache.subcategory,
			"subSubCategory": window.productCache.subsubcategory,
			"productAutoReplen": $(".add-to-cart").data("replenishable"),
			"productOutOfStock": $(".add-to-cart").data("instock"),
			"productColor": selectedColor ? selectedColor : pdpdata.productColor,
			"productType": "Product",
			"productVariantID": pdpdata.master ? pdpdata.defalutvariant : pdpdata.ID,
			"collectionName": pdpdata.customBrand,
			"productOrderType": getProductOrederType()
		}]
	});
}

// add product ai dialog PLP/HP
function addProductAIDialog(productId, quantity, variantId) {
    const addToCartType = $('.product-listing').length > 0 
        ? "Dialog - Product List Page" 
        : "Dialog - Product Page";

    const minicartData = miniBasketConfirmation.productLineItems || [];

    // ✅ Find matching product
    const matchedProduct = minicartData.find(item => 
        item.id == productId || item.productVariantID == variantId
    );

    // ✅ Use matched product if found, else fallback
    const product = matchedProduct || {};

    pushToDataLayer({
        "currencyCode": window.Resources.CURRENCY,
        "event": "addToCart",
        "addToCartType": addToCartType,
        "pageCategory": pageInfo.pageCategory,
        "pageSubCategory": pageInfo.pageSubCategory,
        'products': [{
            "id": product.id || productId,
            "listType": pageInfo.pageCategory,
            "listName": $(".breadcrumb")
                .find(".breadcrumb-element:eq(1)")
                .first()
                .text()
                .trim(),
            "category": product.category || window.productCache.catid,
            "price": product.price,
            "name": product.name || getProductName(),
            "brand": product.brand || getProductBrand(),
            "quantity": quantity,
            "size": product.size || "",
            "subCategory": product.subCategory ?? window.productCache.subcategory ?? "",
            "subSubCategory": product.subSubCategory ?? window.productCache.subsubcategory ?? "",
            "productAutoReplen": product.productAutoReplen || $(".add-to-cart").data("replenishable"),
            "productOutOfStock": product.productOutOfStock || $(".add-to-cart").data("instock"),
            "productColor": product.color || "",
            "productType": product.productType || "Product",
            "productVariantID": product.productVariantID || variantId,
            "collectionName": product.collectionName || "",
            "productOrderType": getProductOrederType()
        }]
    });
}

// add product ai dialog
function trackCartAddition(productId, quantity, currency, price, variantId) {

    // ✅ Check if pdpdata exists and has variant info
    const isPDPVariant = typeof pdpdata !== "undefined" && pdpdata && pdpdata.variant;

    const selectedVariantID = isPDPVariant ? variantId : productId;

    let dataObject = {
        productId: selectedVariantID,
        quantity: quantity,
        price: price,
        currency: currency,
        variantId: selectedVariantID
    };

    // ✅ Safe localStorage handling
    let storedProductIds;
    try {
        storedProductIds = JSON.parse(localStorage.getItem('storedproductid')) || [];
    } catch (e) {
        storedProductIds = [];
    }

    if (!storedProductIds.includes(selectedVariantID)) {
        storedProductIds.push(selectedVariantID);
        localStorage.setItem('storedproductid', JSON.stringify(storedProductIds));
    }

    return dataObject;
}

//pdp ai dialog send message
function sendAIDialogMessage() {
	pushToDataLayer({
		"event": "dialog_send_message"
	});
}

//header-account-icon-click-event
function trackAccountIconClick(isNewNav) {
	if (isNewNav) {
		pushToDataLayer({
			'event': 'header_interaction',
			'header_click': 'Account'
		});

	} else {
		pushToDataLayer({
			'event': 'header_interaction',
			'header_click': 'Account',
			'language_selection': window.User.locale
		});
	}
}

//header-signin-icon-click-event
function trackSignInDrawerOpen() {
    pushToDataLayer({
        'event': 'account_modal'
    });
}

//clicking CTA from the msg (arrow/anchor)
function trackClickCtaAccountModal(loginLocation) {
	var dataObj = {
        'event': 'click_cta_account_modal'
    };
	if (loginLocation) {
        dataObj.loginLocation = loginLocation;
    }
    pushToDataLayer(dataObj);
}

//clicking CTA on login drawer 
function trackClickCtaPerksAccountModal() {
    pushToDataLayer({
        'event': 'click_cta_perks_account_modal'
    });
}
		
function initializeGlobalEvents() {
	var navctr = true;
	var gtmNavData = "";	
	var gtmParent = "";	
	var gtmCategory="";

	$(document)

		// filter selection from page
		.on('click', '.filter-button', function () {
			pushToDataLayer({
				'event' : 'PLPInteractions',
				'interactionType' : 'filter_overlay',
				'filterSelection' : $(this).find(".filter-text").text()
			});
		})

		// filter selection from panel
		.on('click', '.filter-display-results-btn', function () {
			const category = $('.filter-panel-title').text().trim();
			// get list of selected filters
			const $selectedItems = $('.filter-options-list li.filter-list-item.selected');
			if ($selectedItems.length === 0) return;
			// push event for each selected filter
			$selectedItems.each(function () {
				let detailText = $(this).find('span.text').text().trim();
				pushToDataLayer({
					'event' : 'PLPInteractions',
					'pageCategory': pageInfo.pageCategory,
					'pageSubCategory': pageInfo.pageSubCategory,
					'interactionType' : 'filter',
					'filterSelection': category,
					'filterDetailsSelection' : detailText
				});
			});
		})

		// clear filter selection
		.on('click', '.filter-clear-results-btn', function () {
			pushToDataLayer({
				'event' : 'PLPInteractions',
				'pageCategory': pageInfo.pageCategory,
				'pageSubCategory': pageInfo.pageSubCategory,
				'interactionType' : 'clear_filter'
			});
		})

		//pdp ai dialog on question click
		.on("click", ".dialog-suggestion", function () {
			pushToDataLayer({
				"event": "dialog_click_questions"
			});
		})

		// PLP cross navigation
		.on('click', '#cross-cat-nav li', function () {
			var _this = $(this);
			if (_this.attr('data-category') !== 'null' && $('.product-listing').length > 0 ) {
				pushToDataLayer({
					'event': 'list_subcategory_interaction',
					'list_name' : _this.attr('data-parent-category'), 
					'list_subcategory' : _this.attr('data-category')
				});
			}
		})
		
		.on('click', '.plps-container a', function () {
			pushToDataLayer({
				'event': 'list_crossnav_top_interaction',
				'list_subcategory' : $(this).text().trim()
			});
		})

		.on('click', '.cart_container #selectsample , .sample-select-tile, .cart_page .sample-header', function () {
			var _this = $(this);

			pushToDataLayer({
				'event' : 'select_sample',
				'checkoutStep' :'1',
				'pageCategory': pageInfo.pageCategory,
				'pageSubCategory': pageInfo.pageSubCategory,
				'currencyCode':  window.Resources.CURRENCY,
				'collectionName': basketConfirmation.productLineItems[0].collectionName
			});
			
		})

		.on('click', '.cart_container .sample-body .button.multiselect, .cart_page .sample-body .product-tile-wrapper', function () {
			var _this = $(this);
			var $gtmProductTile;
			if ($(this).attr('value') == 'selectable' || $(this).attr('value') == 'selectproduct' || !$(this).hasClass(' product-tile-selected')) {
				if ($('body.cart_page').length > 0) {
					if ($(this).attr('value') == 'selectproduct') {
						$gtmProductTile = _this.closest('.product-tile-wrapper').find('.gtm-product-tile')
					} else {
						$gtmProductTile = _this.find('.gtm-product-tile');
					}
				} else {
					$gtmProductTile = _this.parents(".product-tile-wrapper").find('.gtm-product-tile');
				}
				var tileVariantData = $gtmProductTile.data('value');
				
				pushToDataLayer({
					'event' : 'add_sample',
					'sample_name' : tileVariantData.name,
					'sample_brand' : tileVariantData.brand,
					'checkoutStep' : '1',
					'pageCategory': pageInfo.pageCategory,
					'pageSubCategory': pageInfo.pageSubCategory,
					'currencyCode': window.Resources.CURRENCY,
					'collectionName': tileVariantData.customBrand,
				});	
			}
		})

		.on('click', '#samples-add-to-cart', function () {
			if (window.Resources.PAGE_CATEGORY != 'cart_page') {
				var selectedSamples = $(document).find('.remove').closest('.product-tile-wrapper');
				var sample_added_name = [];
				var sample_brand;
				var collectionName;
				var concatenatedString;
				selectedSamples.each(function () {
					var product = {};
					var gtmValue = $(this).find('.gtm-product-tile');
					var tileVariantData = gtmValue.data('value');
					product.name = tileVariantData.name;
					sample_brand = tileVariantData.brand;
					collectionName = tileVariantData.customBrand;
					sample_added_name.push(product);
				});
				var concatenatedString = '';

				for (var i = 0; i < sample_added_name.length; i++) {
					if (sample_added_name[i].name) { // Check if the 'name' property exists
						if (i > 0 && concatenatedString !== '') {
							concatenatedString += ', ';
						}
						concatenatedString += sample_added_name[i].name;
					}
				}
				var sample_name = concatenatedString.trim();
				var sample_number = sample_added_name.length;
				
				pushToDataLayer({
					'event' : 'add_sample_to_cart', 
					'sample_number' : sample_number,
					'sample_name_listing': sample_name,
					'checkoutStep' : '1',
					'pageCategory': pageInfo.pageCategory,
					'pageSubCategory': pageInfo.pageSubCategory,
					'currencyCode': window.Resources.CURRENCY,
					'collectionName': collectionName,
				});
			}
		})

		.on('click', '#samples-add-to-cart', function () {
			if (window.Resources.PAGE_CATEGORY == 'cart_page') {
				var _this = $(this);
				var sample_added_name = [];
				var addedSamples = $(document).find(".product-tile-selected");
				var sample_brand;
				var collectionName;
				addedSamples.each(function () {
					var product = {};
					var gtmValue = $(this).find('.gtm-product-tile');
					var tileVariantData = gtmValue.data('value');
					product.name = tileVariantData.name;
					sample_brand = tileVariantData.brand;
					collectionName = tileVariantData.customBrand;
					sample_added_name.push(product);
				});
				var concatenatedString = '';

				for (var i = 0; i < sample_added_name.length; i++) {
					if (sample_added_name[i].name) { // Check if the 'name' property exists
						if (i > 0 && concatenatedString !== '') {
							concatenatedString += ', ';
						}
						concatenatedString += sample_added_name[i].name;
					}
				}
				var sample_name = concatenatedString.trim();
				var sample_number = sample_added_name.length;             
				
				pushToDataLayer({
					'event' : 'add_sample_to_cart', 
					'sample_number' : sample_number,
					'sample_name_listing': sample_name,
					'checkoutStep' : '1',
					'pageCategory': pageInfo.pageCategory,
					'pageSubCategory': pageInfo.pageSubCategory,
					'currencyCode': window.Resources.CURRENCY,
					'collectionName': collectionName,
				});
			}
		})

		//reinsurance-content-datalayer-push
		.on('click', '.reinsurance-wrapper', function () {
			var reinsuranceType, clickedIndex, reinsurancePage;
            reinsuranceType = $(this).find('.reinsurance-title').html();
            clickedIndex = $(".reinsurance-wrapper").index(this);
            reinsurancePage = "PDP";
            if (!$(this).find('.reinsuranceDesc').hasClass('open') || $(this).hasClass('open-reinsurance-panel')) {
                pushToDataLayer({
                    'event': 'reinsurance_interaction',
                    'reinsurance_type' : reinsuranceType,
                    'reinsurance_page' : reinsurancePage,
                    'reinsurance_position': clickedIndex + 1
                });
            }
            if($("#reinsurance-panel").length) {
                $("#reinsurance-panel .panel-body .panel-content-buttons").attr({
                    "data-reinsurance-type": reinsuranceType,
                    "data-reinsurance-page": reinsurancePage,
                    "data-reinsurance-position": clickedIndex + 1
                })
            }
		})

		//reinsurance-content-checkout-datalayer-push
		.on('click', '.reinsurance-element', function () {
			var reinsuranceType, clickedIndex, reinsurancePage;
			if( $(this).find('.reinsurance-title').hasClass('order-and-payment-title')) {
				reinsuranceType = $(this).find('.reinsurance-title').html() + " " + $(this).find('.reinsurance-subtitle').html();
			} else {
				reinsuranceType = $(this).find('.reinsurance-title').html();
			}
			if (pageInfo.pageSubCategory === 'Cart Page' || window.Resources.PAGE_CATEGORY == 'cart_page') {
				reinsurancePage = 'Cart Page'
			} else if (pageInfo.pageSubCategory === 'Shipping' || window.Resources.PAGE_CATEGORY == 'coshipping-start') {
				reinsurancePage = 'Shipping'
			} else if (pageInfo.pageSubCategory === 'Payment' || window.Resources.PAGE_CATEGORY == 'coshipping-singleshipping') {
				reinsurancePage = 'Payment'
			}
			clickedIndex = $(".reinsurance-element").index(this);
			if ($(this).find(".reinsurance-wrapper-cart").hasClass('show-description') === true || $(this).hasClass('open-reinsurance-panel')) {
				pushToDataLayer({
					'event': 'reinsurance_interaction',
					'reinsurance_type' : reinsuranceType,
					'reinsurance_page' : reinsurancePage,
					'reinsurance_position': clickedIndex + 1
				});
			}
			if($("#reinsurance-panel").length) {
				$("#reinsurance-panel .panel-body .panel-content-buttons").attr({
					"data-reinsurance-type": reinsuranceType,
					"data-reinsurance-page": reinsurancePage,
					"data-reinsurance-position": clickedIndex + 1
				})
			}
		})

		//reinsurance content helpful datalayer push
		.on('click', '.panel-content-buttons .panel-bottom-yes, .panel-content-buttons .panel-bottom-no', function () {
			var reinsuranceType = $(this).parent().attr("data-reinsurance-type");
			var reinsurancePage = $(this).parent().attr("data-reinsurance-page");
			var clickedIndex = $(this).parent().attr("data-reinsurance-position");
			pushToDataLayer({
				'event': 'reinsurance_interaction',
				'reinsurance_type' : reinsuranceType,
				'reinsurance_page' : reinsurancePage,
				'reinsurance_position': clickedIndex,
				'reinsurance_helpful': $(this).text().trim().toLowerCase()
			});
		})

		//promotion-header-copy-paste
		.on('click', '.copy-promotion-code, .promotion-code-to-copy', function (e) {
			var _this = $(this);
			    pushToDataLayer({
					'event': 'banner_interaction',
					'banner_position' : _this.attr('data-banner_position'),
					'banner_click' : 'copy',
					'banner_name' : _this.attr('data-banner_name'),
					'promotion_code' : _this.attr('data-promotion_code')
				});
		})

		//promotion-header-redirection
		.on('click', '.link-redirection', function (e) {
			var _this = $(this);
			    pushToDataLayer({
					'event': 'banner_interaction',
					'banner_position' : _this.attr('data-banner_position'),
					'banner_click' : 'redirect',
					'banner_name' : _this.attr('data-banner_name'),
				});
		})

		//header-basket-icon-click-event
		.on('click', '.minicart-link .bag-icon', function () {
			const _this = $(this);
			if (_this.closest('.nav-redesign').length) {
				pushToDataLayer({
					'event': 'header_interaction',
					'header_click': 'Basket'
				});

			} else {
			    pushToDataLayer({
					'event': 'header_interaction',
					'header_click' : 'Basket',
  					'language_selection' : window.User.locale
				});
			}
		})

		//header-menu-icon-click-event
		.on('click', '#hamburger', function () {
			const _this = $(this);
			if (_this.closest('.nav-redesign').length) {
				pushToDataLayer({
					'event': 'header_interaction',
					'header_click': 'Menu'
				});

			} else {
			    pushToDataLayer({
					'event': 'header_interaction',
					'header_click' : 'Menu',
  					'language_selection' : window.User.locale
				});
			}
		})
		
		//header-language-icon-click-event
		.on('click', '.languageSelector', function () {
			const _this = $(this);
			if (_this.closest('.nav-redesign').length) {
				pushToDataLayer({
					'event': 'header_interaction',
					'header_click': 'Language'
				});

			} else {
			    pushToDataLayer({
					'event': 'header_interaction',
					'header_click' : 'Account',
  					'language_selection' : window.User.locale === 'fr_BE' ? 'nl_BE' : 'fr_BE' 
				});
			}
		})
		
		//new-header-offers-text-click-event
		.on('click', '.nav-redesign .offers-link a', function (e) {
			pushToDataLayer({
				'event': 'header_interaction',
				'header_click' : 'Offers'
			});
		})

		//footer contactus click
		.on('click', "#contactus-footer", function (e) {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Email Customer Service",
				"siteLocation": "Footer",
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory
			});
		})
		
		//header contactus click
		.on('click', "#contactus-header", function (e) { 
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Email Customer Service",
				"siteLocation": "Header",
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory
			});
		})

		// add to wishlist in pdp, quickview, or edit-cart overlays
		.on('click', '.wishlist-icon', function(e) {
			const $icon     = $(this);
			const eventName = $icon.hasClass('wishlist-added')
							? 'removeFromWishlist'
							: 'clickSaveForLater';
		
			// 1) Cart-row case
			const $cartRow = $icon.closest('.cart-row');
			if ($cartRow.length) {
				const idx  = $cartRow.closest('.js-cart-analytics').index();
				const item = basketConfirmation.productLineItems[idx];
				pushToDataLayer({
					event:                 eventName,
					productCategory:       item.category.split('\n')[0],
					productSubCategory:    item.subCategory.split('\n')[0],
					productSubSubCategory: item.subSubCategory.split('\n')[0],
					productName:           item.name,
					productId:             item.id,
					pageCategory:          pageInfo.pageCategory,
					pageSubCategory:       pageInfo.pageSubCategory
				});
				return;
			}
		
			// 2) PLP OR Quick-view tile
			let data = null;
			const $tile = $icon.closest('.product-tile');
			if ($tile.length) {
				data = $tile.find('.gtm-product-tile').data('value');
			}
			if (!data) {
				const $quick = $icon.closest('.quickview-modal, .quick-shop-panel');
				if ($quick.length) {
					data = $quick.find('.gtm-product-tile').data('value');
				}
			}
		
			// 3) PDP fallback
			if (!data || !Object.keys(data).length) {
				if (window.pdpdata) {
					data = {
					masterID:       pdpdata.masterID,
					ID:             pdpdata.ID,
					catid:          pdpdata.catid || pageInfo.pageSubCategory,
					subcategory:    pdpdata.subcategory,
					subsubcategory: pdpdata.subsubcategory,
					name:           pdpdata.name
					};
				}
			}
		
			// 4) GENERIC overlay fallback (e.g. Shiseido edit-cart)
			if (!data || !Object.keys(data).length) {
				const $ctx = $icon.closest('[data-element-pid], [data-item-id], [data-product-id]');
				if ($ctx.length) {
					data = {
					masterID: $ctx.data('element-pid')
							|| $ctx.data('item-id')
							|| $ctx.data('product-id'),
					name:     $ctx.data('element-name')
							|| $ctx.find('.name, .product-name').text().trim()
					};
				} else {
					console.warn(
					'Wishlist-icon click: no product-tile, quick-view, pdpdata, or generic data-attr',
					$icon
					);
					return;
				}
			}
		
			// ensure data is at least an object
			data = data || {};
		
			// normalize fields
			const cat    = data.catid            || pageInfo.pageSubCategory;
			const sub    = data.subcategory      || '';
			const subsub = data.subsubcategory   || '';
			const name   = data.name             || 'unknown';
			const id     = data.masterID || data.ID || $icon.attr('data-element-pid');
		
			// final push
			pushToDataLayer({
				event:                 eventName,
				productCategory:       cat,
				productSubCategory:    sub,
				productSubSubCategory: subsub,
				productName:           name,
				productId:             id,
				pageCategory:          pageInfo.pageCategory,
				pageSubCategory:       pageInfo.pageSubCategory
			});
		})  

		// newsletter in navigation;
		.on("clicknewsletter", function (e, data) {
			pushToDataLayer({
				"event": "newsletterSubscription",
				"siteLocation": data.siteloc,
				"pageSubCategory": pageInfo.pageCategory == "My Account" ? getProductsubCategory() : "",
				"pageCategory": pageInfo.pageCategory
			});
		})

		// click ask question in pdp
		.on("click", ".bv-ask-question", function (e) {
			pushToDataLayer({
				page: pageInfo.pageCategory,
				"event": "askQuestion",
				productCategory: getProductCategory(),
				pageSubCategory: pageInfo.pageSubCategory,
				productName: getProductName(),
				pageCategory:  pageInfo.pageCategory
			});
		})

		// Click on Reviews in PDP
		.on("click", ".product-detail-bv", function () {
			if(unbind < 1) {
				unbind = 1;
				pushToDataLayer({
					event: "productReviewsView",
					page: window.location.pathname,
					productCategory: getProductCategory(),
					productName: getProductName(),
					pageCategory: pageInfo.pageCategory,
					pageSubCategory: pageInfo.pageSubCategory
				});
			}
		})
		// add to cart from PDP
		.on('click', '#pdpMain .add-to-cart', function (e) { 
			$(this).data('clicked', true);
			//skip for regimenzone
			if($(this).parents().hasClass('regimenzone') || $(this).parents('.recommendation-slide').length > 0){
				return;
			}
			var addToCart = "Product Page";
			if (pageInfo.pageCategory == "Cart Page") {
				if (sessionStorage.getItem("cartupdate")) {
					sessionStorage.setItem("productUpdate", "1");
				}
			} else {
				window.productCache = window.productCache || {};
				var selectedSize = sessionStorage.getItem('selectedVariantSize');
				var selectedColor = sessionStorage.getItem('selectedVariantsColor');
				pushToDataLayer({
					"currencyCode": window.Resources.CURRENCY,
					"event": "addToCart",
					"addToCartType": addToCart,
					"pageCategory": pageInfo.pageCategory,
					'products': [{
						"id": pdpdata.masterID,
						"productVariantID": pdpdata.master ? pdpdata.defalutvariant : pdpdata.ID,
						"listType": pageInfo.pageCategory,
						"listName": $(".breadcrumb").find(".breadcrumb-element:eq(1)").first().text().trim(),
						"category": window.productCache.catid,
						"price": pdpdata.pricing ? pdpdata.pricing.sale ? pdpdata.pricing.sale : pdpdata.pricing.minprice ? pdpdata.pricing.minprice : null : null,
						"name": getProductName(),
						"brand": getProductBrand(),
						"quantity": Number($(".quantity select").val()),
						"size":  selectedSize ? selectedSize : pdpdata.size,
						"subCategory": window.productCache.subcategory,
						"subSubCategory": window.productCache.subsubcategory,
						"productAutoReplen": $(".add-to-cart").data("replenishable"),
						"productOutOfStock": $(".add-to-cart").data("instock"),
						"productColor": selectedColor ? selectedColor : pdpdata.productColor,
						"productType": "Product",
						"collectionName": pdpdata.customBrand,
						"productNumReviews": pdpdata.productNumReviews,
						"productOrderType": getProductOrederType(),
						"productStarRating": pdpdata.productStarRating
					}]
				});
			}
		})

		// Submit ask a question
		.on('click', ".bv-submission-section button:contains('Post Question')", function (e) {
			pushToDataLayer({
				"page": pageInfo.pageCategory,
				"event": "submitQuestion",
				"productCategory": getProductCategory(),
				"question": $("#bv-textarea-field-questionsummary").val(),
				"productName": getProductName(),
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory
			});
		})

		// remove from cart
		.on('click', ".user-action-remove .btn-remove-cart-item", function (e) {
			var index = $(this).parents(".js-cart-analytics").index();		

			if($(this).parents(".js-cart-analytics").find('.bonus-product').length > 0){//if bonus product -1 index
				index = index - 1;
			}

			if(typeof basketConfirmation.productLineItems[index] != undefined){
				pushToDataLayer({
					"currencyCode": window.Resources.CURRENCY,
					"event": "removeFromCart",
					"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
					"pageCategory": pageInfo.pageCategory,
					'products': [{
						"id": basketConfirmation.productLineItems[index].id,
						"category": basketConfirmation.productLineItems[index].category,
						"price": basketConfirmation.productLineItems[index].price,
						"name": basketConfirmation.productLineItems[index].name,
						"brand": getProductBrand(),
						"quantity": basketConfirmation.productLineItems[index].quantity,
						"size": basketConfirmation.productLineItems[index].size,
						"subCategory": basketConfirmation.productLineItems[index].subCategory,
						"subSubCategory": basketConfirmation.productLineItems[index].subSubCategory,
						"productAutoReplen": basketConfirmation.productLineItems[index].productAutoReplen,
						"productOutOfStock": basketConfirmation.productLineItems[index].productOutOfStock,
						"productColor": basketConfirmation.productLineItems[index].productColor,
						"productType": basketConfirmation.productLineItems[index].productType,
						"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
						"productVariantID": basketConfirmation.productLineItems[index].productVariantID,
						"collectionName": basketConfirmation.productLineItems[index].collectionName
					}]
	
				})
			}

		})

		// remove from minicart
		.on('click', ".mini-cart-details .remove-link", function (e) {
			var index = $(this).parents(".mini-cart-product").index();
			index = index != 0 ? index-1 : 0;
			pushToDataLayer({
				"currencyCode": window.Resources.CURRENCY,
				"event": "removeFromCart",
				"pageCategory": pageInfo.pageCategory,
				'products': [{
					"id": miniBasketConfirmation.productLineItems[index].id,
					"category": miniBasketConfirmation.productLineItems[index].category,
					"price": miniBasketConfirmation.productLineItems[index].price,
					"name": miniBasketConfirmation.productLineItems[index].name,
					"brand": getProductBrand(),
					"quantity": miniBasketConfirmation.productLineItems[index].quantity,
					"size": miniBasketConfirmation.productLineItems[index].size,
					"subCategory": miniBasketConfirmation.productLineItems[index].subCategory,
					"subSubCategory": miniBasketConfirmation.productLineItems[index].subSubCategory,
					"productAutoReplen": miniBasketConfirmation.productLineItems[index].productAutoReplen,
					"productOutOfStock": miniBasketConfirmation.productLineItems[index].productOutOfStock,
					"productColor": miniBasketConfirmation.productLineItems[index].productColor,
					"productType": miniBasketConfirmation.productLineItems[index].productType,
					"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
					"productVariantID": miniBasketConfirmation.productLineItems[index].productVariantID,
					"collectionName": miniBasketConfirmation.productLineItems[index].collectionName
				}]
			})

		})
		// click zoom in pdp
		.on('click', ".productthumbnail.selected", function (e) {
			if ($('.quickview-modal').length === 0 && $('.quick-shop-panel').length === 0) {
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"productName": typeof productCache != undefined && productCache.productSet ? productCache.name : getProductName(),
					"pageCategory": pageInfo.pageCategory,
					"productId": getProductID(),
					"interactionType": "Zoom"
				})
			}
		})

		//click  Try it in pdp
		.on('click', ".try-it-on", function (e) {
			if ($('.quickview-modal').length === 0) {
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"productName": getProductName(),
					"pageCategory": pageInfo.pageCategory,
					"productId": getProductID(),
					"interactionType": "Try it on"
				})
			}
		})
		
		//click  Try it in pdp
		.on('click', ".pdp-accordion__header", function (e) {
			if ($('.quickview-modal').length === 0 && $(this).hasClass('ui-accordion-header-active')) {
				var interactionType;
				if($('.pdp-redesign').length >= 1) {
					interactionTypeText = $(this).find('.pdp-accordion__header-text').contents().filter(function() {
						return this.nodeType === 3; // Select text nodes
					}).text().trim();
				} else {
					interactionTypeText = $(this).contents().filter(function() {
						return this.nodeType === 3; // Select text nodes
					}).text().trim();
				}

				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": $(".breadcrumb").find(".breadcrumb-element span").html(),
					"productSubCategory": $(".breadcrumb").find(".breadcrumb-element:eq(1) span").html(),
					"productName": getProductName(),
					"pageCategory": pageInfo.pageCategory,
					"pageSubCategory": pageInfo.pageSubCategory,
					"productId": getProductID(),
					"interactionType": interactionTypeText
				})
			}
		})
		
		//click  Store Locator in pdp
		.on('click', ".find-store.inline-links__item-anchor", function (e) {
			if ($('.quickview-modal').length === 0) {
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"productName": getProductName(),
					"pageCategory": pageInfo.pageCategory,
					"productId": getProductID(),
					"interactionType": "Store Locator"
				})
			}
		})
		
		//click  Remind Me/ coming soon in pdp
		.on('click', ".back-in-stock-wrapper .button", function (e) {
			if ($('.quickview-modal').length === 0) {
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"productName": getProductName(),
					"pageCategory": pageInfo.pageCategory,
					"productId": getProductID(),
					"interactionType": $('.coming-soon-notify').length ? "Cooming soon" : "Remind Me"
				})
			}
		})
		// click full ingredients in pdp
		.on('click', "#keyingredients .view-all.button.tertiary", function (e) {
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": pageInfo.pageCategory,
				"productId": getProductID(),
				"interactionType": "View Full Product Ingredients"
			})
		})

		.on("click", ".cart-promo-approaching", function () {
			pushToDataLayer({
				"event": "eePromoClick",
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory,
				'promotions': [{
					"position": "Cart",
					"id": $(".cart-promo-approaching").data("promoid"),
					"creative": "Cart-Banner",
					"name": $(".cart-promo-approaching").data("promoname")
				}]
			})
		})

		.on("click", ".cart-coupon-code #add-coupon", function () {
			localStorage.removeItem('couponvalidation');
		})

		// track share button on PDP
		.on("click", ".socialsharing .share-icon", function () {
			pushToDataLayer({
				"socialAction": "Share",
				"event": "socialShare",
				"siteLocation": "product page",
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"socialNetwork": $(this).data("share")
			})
		})

		// Track Follow button on Footer
		.on("click", ".social-links a", function () {
			pushToDataLayer({
				"socialAction": "Follow",
				"event": "socialFollow",
				"siteLocation": "footer",
				"pageCategory": pageInfo.pageCategory,
				"socialNetwork": $(this).data("follow")
			})
		})

		// Add to all to Cart
		.on("click", ".add-all-to-cart, #add-all-to-cart", function () {
			var $regimenbg = productCache.productSet ? $(document).find(".regimen-bg") :  $(this).parents(".regimen-bg");
			var productsList = [];
			$regimenbg.find('.gtm-product-tile').each(function () {
				var product = {};
				var tileVariantData = $(this).data('value');
				product.ID = tileVariantData.masterID || tileVariantData.ID;
				product.productVariantID = tileVariantData.ID;
				product.category = tileVariantData.catid;
				product.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
				product.name = tileVariantData.name;
				product.brand = tileVariantData.brand;
				product.quantity = productCache.productSet ? $("#quantity").val() : tileVariantData.quantity;
				product.size = tileVariantData.size;
				product.subCategory = tileVariantData.subcategory;
				product.subSubCategory = tileVariantData.subsubcategory;
				product.productAutoReplen = tileVariantData.productautoreplenish;
				product.productOutOfStock = tileVariantData.productOutOfStock;
				product.productColor = tileVariantData.productColor;
				product.productType = "Product";
				product.collectionName = tileVariantData.customBrand;
				product.productNumReviews = tileVariantData.productNumReviews;
				product.productStarRating = tileVariantData.productStarRating;
				product.productOrderType = getProductOrederType();
				productsList.push(product);
			});
			
			
			pushToDataLayer({
				"currencyCode": window.Resources.CURRENCY,
				"event": "addToCart",
				"addToCartType": $(this).parents().hasClass('regimenzone') ? "Add All to Bag - Regimen" : pageInfo.pageCategory,
				"pageSubCategory": getProductsubCategory(),
				"pageCategory": (typeof productCache != 'undefined' && productCache.productSet) ? "Product Bundle Page" : pageInfo.pageCategory,
				"products": productsList
			});
		})

		// click email hyper link in navigation
		.on('click', '.emailcsr-nav', function () {
			if (window.Resources.PAGE_CATEGORY == "page-show") {
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Email",
					"siteLocation": "Header",
					//"pageSubCategory": pageInfo.pageSubCategory,
					"pageCategory": getProductCategory()
				});

			} else {
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Email",
					"siteLocation": "Header",
					"pageSubCategory": window.Resources.PAGE_CATEGORY == "cart-show" ? "" : pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory
				});
			}

		})
		// Click email link in the customer care
		.on("click", ".content-asset a:contains('customerservice@shiseidousa.com')", function () {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Email",
				"siteLocation": window.Resources.PAGE_CATEGORY == "cart-show" ? "Right Nav" : "Body",
				//"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": window.Resources.PAGE_CATEGORY == "cart-show" ? pageInfo.pageCategory : getProductCategory()
			});
		})

		.on("gtmcontactus", function () {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Contact Customer Care Submission",
				"siteLocation": "Body",
				"pageCategory": pageInfo.pageCategory
			});
		})
		.on("askanexpert", function () {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Ask An Expert Submission",
				"siteLocation": "Body",
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory":pageInfo.pageCategory
			});
		})

		.on("click", ".LPMcontainer", function () {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Live Chat",
				"siteLocation": pageInfo.pageCategory == "Checkout Page" ? "Header" : "Body",
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory
			});
		})

		.on("click", ".LPMimage", function () {
			var id = $(this).attr("id");
			var chk = id.charAt(id.length - 1)
			if (chk == 1) {
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Live Chat",
					"siteLocation": "Pop-up",
					"pageSubCategory": pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory
				});
			}
		})

		.on("click", ".footer-container .products ul li:nth-child(4)", function () {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Phone",
				"siteLocation": "Footer",
				"pageSubCategory": window.Resources.PAGE_CATEGORY == "cart-show" ? "" : pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory
			});
		})

		// click on recommendation
		.on("click", ".recommendation-item", function () {
			if (pageInfo.pageCategory == "Product Page") {
				sessionStorage.setItem('listType', "Einstein");
				sessionStorage.setItem('listName', "Product Page");
			} else if (pageInfo.pageCategory == "Home Page") {
				sessionStorage.setItem('listType', "Einstein");
				sessionStorage.setItem('listName', "Home Page");
			}

		})

		.on("click", ".catalog-link", function (e) {
			if (navctr == true) {
				gtmNavData =$(this).attr('data-link-name');
				sessionStorage.setItem("navlink", gtmNavData);
				sessionStorage.setItem("menuloc", "topmenu");
				util.setCookie('navdata', gtmNavData, .20);
				navctr = false;
			}
		})
		
		.on("click", ".cross-cat-nav a", function (e) {
			if (navctr == true) {
				gtmNavData = $(this).text().trim();
				sessionStorage.setItem("navlink", gtmNavData);
				sessionStorage.setItem("menuloc", "mobile submenu");
				util.setCookie('navdata', gtmNavData, .20);
				navctr = false;
			}
		})

		.on("click", ".main-nav .has-sub-menu a", function (e) {
			if (navctr == true) {
				gtmNavData =$(this).attr('data-link-name');
				sessionStorage.setItem("navlink", gtmNavData);
				sessionStorage.setItem("menuloc", "topmenu");
				util.setCookie('navdata', gtmNavData, .20);
				navctr = false;
			}
		})

		.on("click", ".main-nav .level-2-link a", function (e) {
			gtmNavData =$(this).attr('data-link-name');
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "topmenu");
			util.setCookie('navdata', gtmNavData, .20);
			navctr = false;
		})

		.on("click", ".main-nav .level-3-link a", function (e) {
			gtmNavData =$(this).attr('data-link-name');
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "topmenu");
			util.setCookie('navdata', gtmNavData, .20);
			navctr = false;
		})

		.on("click", ".main-nav .no-sub-cat-2 a", function (e) {
			gtmNavData =$(this).attr('data-link-name');
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "topmenu");
			util.setCookie('navdata', gtmNavData, .20);
			navctr = false;
		})

		.on("click", ".main-nav .no-sub-menu a", function (e) {
			gtmNavData =$(this).attr('data-link-name');
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "topmenu");
			util.setCookie('navdata', gtmNavData, .20);
			navctr = false;
		})
		
		.on('click','.redesign-nav .no-sub-menu', function () {
			const $this = $(this);
			const $listName = $this.find('a');
			const $listNameValue = $listName.length && $listName.text() ? $listName.text().trim() : null;
			pushToDataLayer({
				'event' : 'menu_interaction',
				'list_name' : $listNameValue,
			})
		})
		.on('click', '.redesign-nav .js-hover .no-sub-cat-2 a, .redesign-nav .js-hover .has-sub-nav .no-link', function(e) {
			const $this = $(this);
			const $listNameValue = $this.data('topcategory');
			const $listCategory = $this.attr('datasubcategory') || $this.data('link-name');
			e.stopImmediatePropagation();
			pushToDataLayer({
				'event' : 'menu_interaction',
				'list_name' : $listNameValue,
				'list_category' : $listCategory,
			})
		})
		.on('click', '.redesign-nav .level-2-all', function() {
			const $this = $(this);
			const $listName = $this.closest('.back-link').find('.cat-name');
			const $listNameValue = $listName.length && $listName.text() ? $listName.text().trim() : null;
			pushToDataLayer({
				'event' : 'menu_interaction',
				'list_name' : $listNameValue,
				'list_category' : 'view_all',
			})
		})
		.on('click','.redesign-nav .subcat_link' ,function (e) {
			const $this = $(this);
			const $listSubCategory = $this.data('link-name');
			const $listCategoryValue = $this.attr('datasubcategory');
			const $listNameValue = $this.data('topcategory');

			e.stopImmediatePropagation();
			pushToDataLayer({
				'event' : 'menu_interaction',
				'list_name' : $listNameValue,
				'list_category' : $listCategoryValue,
				'list_subcategory' : $listSubCategory,
			})
		})
		.on('click','.redesign-nav .promo-content-wrapper', function () {
			const $this = $(this);
			const $listName = $this.closest('.has-sub-menu').find('.level1-cat-name');
			const $listNameValue = $listName.length && $listName.text() ? $listName.text().trim() : null;
			const $listSubCategory = $this.find('.promo-badge');
			const $listSubCategoryValue = $listSubCategory.length && $listSubCategory.text() ? $listSubCategory.text().trim() : null;
			pushToDataLayer({
				'event' : 'menu_interaction',
				'list_name' : $listNameValue,
				'list_category' : 'promo_banner',
				'list_subcategory' : $listSubCategoryValue,
			})
		})

		.on("click", ".refinement-header", function (e) {
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "leftmenu");
		})

		.on("click", ".refinement-link", function (e) {
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "leftmenu");
		})

		.on("click", ".breadcrumb-element", function (e) {
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("breadcrumbs", gtmNavData);
			sessionStorage.setItem("menuloc", "leftmenu");
		})
		.off("click", ".no-sub-cat-2 a").on("click", ".no-sub-cat-2 a", function(e){
			gtmNavData =$(this).attr('data-link-name');
			sessionStorage.setItem("navlink", gtmNavData);		
			gtmParent =$(this).attr('data-topcategory');
			sessionStorage.setItem("parentnavlink", gtmParent);						
			pushToDataLayer({				
				'event' : 'menu_interaction',
				'list_name' : sessionStorage.getItem('parentnavlink'),
				'list_category' : sessionStorage.getItem('navlink')
			});
		})
		.off("click", ".main-nav .level-3-link .see-all-link").on("click", ".main-nav .level-3-link .see-all-link", function(e){
			gtmNavData =$(this).attr('datasubcategory');
			sessionStorage.setItem("navlink", gtmNavData);		
			gtmParent =$(this).attr('data-topcategory');
			sessionStorage.setItem("parentnavlink", gtmParent);						
			pushToDataLayer({				
				'event' : 'menu_interaction',
				'list_name' : sessionStorage.getItem('parentnavlink'),
				'list_category' : sessionStorage.getItem('navlink')
			});
		})
		.off("click", ".level-3 .level-3-link .subcat_link").on("click", ".level-3 .level-3-link .subcat_link", function(e){
			gtmNavData =$(this).attr('data-link-name');
			sessionStorage.setItem("navlink", gtmNavData);		
			gtmParent =$(this).attr('data-topcategory');
			sessionStorage.setItem("parentnavlink", gtmParent);
			gtmCategory =$(this).attr('datasubcategory');
			sessionStorage.setItem("subnavlink", gtmCategory);				
			pushToDataLayer({				
				'event' : 'menu_interaction',
				'list_name' : sessionStorage.getItem('parentnavlink') ,
				'list_category' : sessionStorage.getItem('subnavlink') ,
				'list_subcategory': sessionStorage.getItem('navlink') 
			});
		})

		.on("focus selectmenufocus", "select.cart-qty-select", function (e) {
			// Store the current value on focus, before it changes
			$(this).find(':selected').addClass('focussed')
		})
		.on("selectmenuchange change", ".cart-qty-select", function (e) {
			var _this = $(this);
			var index = _this.parents(".js-cart-analytics").index();
			
			if (pageInfo.pageCategory == "Cart Page") {
				if ($(".edit-modal").length > 0) {
					sessionStorage.setItem("cartupdate", "1");
				} else {
					sessionStorage.setItem("productUpdate", "1");
				}
			} 
			var previous = $('select.cart-qty-select .focussed').val();
				if(previous != 'undefined' && $(this).val() > previous) {
					pushToDataLayer({
						"currencyCode": window.Resources.CURRENCY,
						"event": "addToCart",
						"addToCartType": pageInfo.pageCategory,
						"pageSubCategory": pageInfo.pageSubCategory,
						"pageCategory": pageInfo.pageCategory,
						'products': [{
							"id": basketConfirmation.productLineItems[index].id,
							"category": basketConfirmation.productLineItems[index].category,
							"price": basketConfirmation.productLineItems[index].price,
							"name": basketConfirmation.productLineItems[index].name,
							"brand": getProductBrand(),
							"quantity": $(this).val() - previous,
							"size": basketConfirmation.productLineItems[index].size,
							"subCategory": basketConfirmation.productLineItems[index].subCategory,
							"subSubCategory": basketConfirmation.productLineItems[index].subSubCategory,
							"productAutoReplen": basketConfirmation.productLineItems[index].productAutoReplen,
							"productOutOfStock": basketConfirmation.productLineItems[index].productOutOfStock,
							"productColor": basketConfirmation.productLineItems[index].productColor,
							"productType": basketConfirmation.productLineItems[index].productType,
							"productVariantID": basketConfirmation.productLineItems[index].productVariantID,
							"productOrderType":getProductOrederType,
							"collectionName": basketConfirmation.productLineItems[index].collectionName
						}]
					})
				} else {
					pushToDataLayer({
						"currencyCode": window.Resources.CURRENCY,
						"event": "removeFromCart",
						"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
						"pageCategory": pageInfo.pageCategory,
						'products': [{
							"id": basketConfirmation.productLineItems[index].id,
							"category": basketConfirmation.productLineItems[index].category,
							"price": basketConfirmation.productLineItems[index].price,
							"name": basketConfirmation.productLineItems[index].name,
							"brand": getProductBrand(),
							"quantity": previous - $(this).val(),
							"size": basketConfirmation.productLineItems[index].size,
							"subCategory": basketConfirmation.productLineItems[index].subCategory,
							"subSubCategory": basketConfirmation.productLineItems[index].subSubCategory,
							"productAutoReplen": basketConfirmation.productLineItems[index].productAutoReplen,
							"productOutOfStock": basketConfirmation.productLineItems[index].productOutOfStock,
							"productColor": basketConfirmation.productLineItems[index].productColor,
							"productType": basketConfirmation.productLineItems[index].productType,
							"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
							"productVariantID": basketConfirmation.productLineItems[index].productVariantID,
							"collectionName": basketConfirmation.productLineItems[index].collectionName
						}]
	
					})
				}
		})
		.on("change", ".quantity-select", function (e) {
			if (window.Resources.PAGE_CATEGORY == "wishlist-show") {
				sessionStorage.setItem("productUpdate", "1");
			}
		})

		.on("click", ".account-left-nav li", function (e) {
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "leftmenu");
		})

		// Remove uservalidation attribute for userlogin validation
		.on('click', ".user-links .log-out-link", function (e) {
			localStorage.removeItem('uservalidation');
			sessionStorage.removeItem('uservalidation');
			localStorage.removeItem("storeDetailsSection");
			localStorage.removeItem("selectedStoreData");
			localStorage.removeItem("royalMail-edit");
		 	localStorage.removeItem("storedAddressData");
		})

		.on("loginDataChanged", function(e) {
			if(window.User.isCustomerAuthenticated) {
				pushToDataLayer({
					"event": "accountLogin",
					'userId':window.User.customerNo,
					'accountType':window.User.isExternallyAuthenticated,
					'pageSubCategory':pageInfo.pageSubCategory,
					'pageCategory': pageInfo.pageCategory,
					"funnelType": 'Account',
					'socialType': localStorage['socialLoginType'] ? localStorage['socialLoginType'] : 'null',
					'loginLocation': 'Logged in outside checkout'
				});
				localStorage['uservalidation'] = true;
				sessionStorage.setItem('uservalidation',true);
				if(localStorage['socialLoginType'] != undefined){
					localStorage.removeItem('socialLoginType'); 
				}
			}
		})

		.on("click","#login", function(){
			if(window.User.isRegistered && !sessionStorage.getItem('uservalidation')){
				pushToDataLayer({
						"event": "accountLogin",
						'userId':window.User.customerNo,
						'accountType':window.User.isExternallyAuthenticated,
						'pageSubCategory':pageInfo.pageSubCategory,
						'pageCategory': pageInfo.pageCategory,
						'loginLocation': 'Logged in outside checkout',
						'socialType': localStorage['socialLoginType'] ? localStorage['socialLoginType'] : 'null'
					});
				sessionStorage.setItem('uservalidation',true);
				localStorage.setItem('uservalidation',true);
				if(localStorage['socialLoginType'] != undefined){
					localStorage.removeItem('socialLoginType'); 
				}
			}
		})

		.on('click',".account-left-nav li[data-attr='account-log-out'], .log-out-link" ,function () {
			localStorage.setItem("userAuth", "loggedOut");
			localStorage.removeItem('uservalidation');
			sessionStorage.removeItem('uservalidation');
		})

		.on("change", "#va-color", function () {
			if (pageInfo.pageCategory == "Cart Page") {
				sessionStorage.setItem("cartupdate", "1");
			}
		})

		.on("click", ".close-button", function () {
			if (pageInfo.pageCategory == "Cart Page") {
				sessionStorage.setItem("cartupdate", "");
			}
		})

		.on("click", "#save-for-later", function () {
			if (pageInfo.pageCategory == "Cart Page") {
				sessionStorage.setItem("cartupdate", "");
			}
		})

		.on("click", "#pdp-swatches .selectable", function () {
			if (pageInfo.pageCategory == "Cart Page") {
				if (!$(this).hasClass("selected")) {
					sessionStorage.setItem("cartupdate", "1");
				}
			}
		})

		.on("click", "#pdp-swatches li.remaining-count, .custom-dd-disabled .custom-dd-list-item-selected", function (e) {
			e.preventDefault();
			if (pageInfo.pageCategory == "Product Page") {
				pushToDataLayer({
					"event": "productInteraction",
					"productName": $("h1.product-name").html().trim(),
					"productId": getProductID(),
					"interactionType" : "open_shade_drawer"
				})
			}
		})

		.on("click", ".search-suggestion-wrapper .hit", function () {
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData.replace(/\s\s+/g, ' '));
			sessionStorage.setItem("menuloc", "site search pop-in");
		})

		.on("click", ".search-suggestion-wrapper .product-suggestion", function () {
			gtmNavData = $(this).text().trim();
			var rep = gtmNavData.replace(/\n/g, " ");
			sessionStorage.setItem("navlink", rep.replace(/ +/g, " "));
			sessionStorage.setItem("menuloc", "site search pop-in");
		})
		
		// Unified Product Click Handler — Thumbnail + Name
		.on("click", ".product-tile .thumb-link, .product-tile a.product-link", function (e) {
			const $this = $(this);
			if(!$this.parents('#search-result-items').length) {
				return;
			}

			const $el   = $(this);
			const $tile = $el.closest(".product-tile"); // correct tile class
			const raw   = $tile.find("input.gtm-product-tile");

			if (!raw.length) {
				console.warn("[PLP] Missing .gtm-product-tile input in:", $tile);
				return;
			}

			let data = {};
			try {
				data = raw.data("value") || JSON.parse(raw.attr("data-value") || {});
			} catch (err) {
				console.error("[PLP] JSON parse error on data-value", err, raw.attr("data-value"));
				return;
			}

			// Normalize ID
			const idVal  = data.id || data.ID || data.masterID;
			const vidVal = data.productVariantID || data.variantID || idVal;
			if (!idVal) {
				console.error("[PLP] no tileData.id — check selector!", data);
				return;
			}
			data.id = idVal;
			data.productVariantID = vidVal;

			// Normalize shape like NARS
			const prod = {
				brand:             data.brand || data.customBrand,
				category:          data.category || data.catid || data.categoryID,
				categoryID:        data.categoryID || data.catid,
				color:             data.color || data.productColor,
				id:                idVal,
				listName:          pageInfo.pageCategory == 'My Account' ? 'Favorite' : listName(),
				listType:          pageInfo.pageCategory == 'My Account' ? pageInfo.pageCategory : listType(),
				name:              data.name,
				position:          data.position || 0,
				price:             data.price || (data.pricing?.sale) || 0,
				productAutoReplen: data.productAutoReplen || data.replenishmentCycle || "No",
				productOutOfStock: data.productOutOfStock || (data.availability?.inStock ? "in-stock" : "out-of-stock"),
				productColor:      data.productColor,
				productType:       data.productType,
				productVariantID:  vidVal,
				quantity:          data.quantity || 1,
				subCategory:       data.subCategory || data.subcategory,
				subCategoryID:     data.subCategoryID || data.subcategoryID,
				variant:           data.variant || ""
			};

			const nextPage = $el.attr("href");

			pushToDataLayer({
				event:          "eeListClick",
				eeAction:       "eeListClick",
				nextPage:       nextPage,
				pageSubCategory:  pageInfo.pageSubCategory,
				pageCategory:   pageInfo.pageCategory,
				filterChoice:   getActiveSortingRule(),
				dropDown:       getRefinementsFromURL(),
				products:       [prod]
			});

			sessionStorage.setItem("listType", pageInfo.pageCategory == 'My Account' ? pageInfo.pageCategory : listType());
			sessionStorage.setItem("listName", pageInfo.pageCategory == 'My Account' ? 'Favorite' : listName());
		})

		// PLP click in list view details
		.on("click", "#search-result-items .gtmindex .buy-button", function () {
			var index = $(this).parents(".gtmindex").index(".gtmindex");
			var pid = $(this).parents(".product-tile").data("itemid");
			
			if (index >= 0) {
				for (var i = 0; i < prodholder.length; i++) {
					if (prodholder[0] && (prodholder[0][i].productVariantID == pid || prodholder[0][i].id == pid)) {
						index = i;
						break;
					}
				}
				
				if (productData.page >= 0 && (prodholder[0] && prodholder[0][index] === undefined)) {
					pushToDataLayer({
						"event": "eeListClick",
						"pageSubCategory": "",
						"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
						"filterChoice": getActiveSortingRule(),
						"dropDown": getRefinementsFromURL(),
						'products': [prodholder[index]]
					})
					sessionStorage.setItem('listType', prodholder[index].listType);
					sessionStorage.setItem('listName', prodholder[index].listName);
				} else {
					pushToDataLayer({
						"event": "eeListClick",
						"pageSubCategory": "",
						"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
						"filterChoice": getActiveSortingRule(),
						"dropDown": getRefinementsFromURL(),
						'products': [prodholder[0][index]]
					})
					sessionStorage.setItem('listType', prodholder[0][index].listType);
					sessionStorage.setItem('listName', prodholder[0][index].listName);
				}

			}
		})

		// Recently viewed eelistclick in homepage
		.on("click", ".cross-sell #recommendation .recommendation-item", function (e) {
			var index = $(this).index();
			if (typeof recentforpageload.product[index] != undefined && recentforpageload.product[index] != null && !$(this).closest('.plp-cross-sell').length) {
				pushToDataLayer({
					"event": "eeListClick",
					"pageSubCategory": "",
					"pageCategory": pageInfo.pageCategory,
					"filterChoice": "",
					"dropDown": "",
					'products': [{
						"listType": "Einstein",
						"listName": pageInfo.pageCategory,
						"position": recentforpageload.product[index].position,
						"id": recentforpageload.product[index].id,
						"category": getProductCategory(),
						"price": recentforpageload.product[index].price,
						"name": recentforpageload.product[index].name,
						"brand": getProductBrand(),
						"quantity": recentforpageload.product[index].quantity,
						"size": recentforpageload.product[index].size,
						"subCategory": recentforpageload.product[index].subCategory,
						"subSubCategory": recentforpageload.product[index].subSubCategory,
						"productAutoReplen": recentforpageload.product[index].productAutoReplen,
						"productOutOfStock": recentforpageload.product[index].productOutOfStock,
						"productColor": recentforpageload.product[index].productColor,
						"productType": recentforpageload.product[index].productType,
						"productNumReviews": "",
						"productStarRating": ""
					}]
				})
				sessionStorage.setItem('listType', "Einstein");
				sessionStorage.setItem('listName', pageInfo.pageCategory);
			}
		})

		// eeListClick datalayer for minicart
		.on("click", ".mini-cart-product .mini-cart-image, .mini-cart-details .mini-cart-name", function () {
			if($(this).hasClass('mini-cart-name')){
				var position = $(".mini-cart-details .mini-cart-name").index($(this)) + 1;
			} else{
				var position = $(".mini-cart-product .mini-cart-image").index($(this)) + 1;
			}
			var index = $(this).parents(".mini-cart-product").index();

			if (miniBasketConfirmation.productLineItems.length) {
				pushToDataLayer({
					"currencyCode": window.Resources.CURRENCY,
					"pageSubCategory": pageInfo.pageSubCategory,
					"event": "eeListClick",
					"pageCategory": pageInfo.pageCategory,
					'products': [{
						"listType": "Mini Cart",
						"listName": "Articles in cart",
						"position": position,
						"id": miniBasketConfirmation.productLineItems[index].id,
						"category": miniBasketConfirmation.productLineItems[index].category,
						"price": miniBasketConfirmation.productLineItems[index].price,
						"name": miniBasketConfirmation.productLineItems[index].name,
						"brand": getProductBrand(),
						"quantity": miniBasketConfirmation.productLineItems[index].quantity,
						"subCategory": miniBasketConfirmation.productLineItems[index].subCategory,
						"subSubCategory": miniBasketConfirmation.productLineItems[index].subSubCategory,
						"productAutoReplen": miniBasketConfirmation.productLineItems[index].productAutoReplen,
						"productOutOfStock": miniBasketConfirmation.productLineItems[index].productOutOfStock,
						"productColor": miniBasketConfirmation.productLineItems[index].productColor,
						"productType": miniBasketConfirmation.productLineItems[index].productType,
						"productVariantID": miniBasketConfirmation.productLineItems[index].productVariantID,
						"collectionName": miniBasketConfirmation.productLineItems[index].collectionName
					}]
				})
			}	
		})

		// cartClicked datalayer for minicart and nav
		.on("click", ".minicart-link .minicart.opened .mini-cart-totals .cart-link, .minicart-link .bag-icon", function () {
			
			if($(this).hasClass('bag-icon')){
				var cartClicked = "navCart";
			} else{
				var cartClicked = "miniCart";
			}
			localStorage.setItem("cartClicked", cartClicked);
	})

		// eeListClick datalayer for Einstein recommendation
		.on("click", ".recommendation-container #recommendation .recommendation-slide .product-tile a.thumb-link, .recommendation-container #recommendation .recommendation-slide .product-tile .name-link, .cross-sell #recommendation .product-tile-info", function () {
			if(!$(this).closest('.plp-cross-sell, .pt_collectionrange .cross-sell-wrapper').length) {
				if($(this).hasClass('name-link')){
					var position = $(".recommendation-slide .product-tile .name-link").index($(this)) + 1;
				} else{
					var position = $(".recommendation-slide .product-tile a.thumb-link").index($(this)) + 1;

				}
				var $gtmProductTile = $(this).parents(".product-tile").find('.gtm-product-tile');
				var tileVariantData = $gtmProductTile.data('value');
				var $productID = $(this).parents(".product-tile").data('itemid');
				var $trackingID = $(this).parents(".product-tile").data('trackingid');
				var $url = $(this).parents(".product-tile").data('url');

				pushToDataLayer({
					"event": "eeListClick",
					"pageCategory": pageInfo.pageCategory,
					"pageSubCategory": pageInfo.pageSubCategory,
					'products': [{
						"listType": "Einstein",
						"list": $('.page-not-found-404').length > 0 ? "404 Page"  : ($(".no-search-text-wrapper").length > 0 ? "Site Search" : (pageInfo.pageCategory)),
						"listName": $('.page-not-found-404').length > 0 ? "404 Page"  : ($(".no-search-text-wrapper").length > 0 ? "Site Search" : (pageInfo.pageCategory)),
						"id": tileVariantData.masterID,
						"productVariantID": tileVariantData.master ? tileVariantData.defalutvariant : tileVariantData.ID,
						"category": tileVariantData.catid,
						"price": tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice,
						"name": tileVariantData.name,
						"position":position,
						"brand": tileVariantData.brand,
						"quantity": tileVariantData.quantity,
						"size": tileVariantData.size,
						"subCategory": tileVariantData.subcategory,
						"subSubCategory": tileVariantData.subsubcategory,
						"productAutoReplen": tileVariantData.productautoreplenish,
						"productOutOfStock": tileVariantData.productOutOfStock,
						"productColor": tileVariantData.productColor,
						"productType": "Product",
						"collectionName": tileVariantData.customBrand,
						"productNumReviews": tileVariantData.productNumReviews,
						"productStarRating": tileVariantData.productStarRating
					}]
				})
			}
		})

		// click on viewmore button
		.on("plpviewmore", function (e) {
			if (pageInfo.pageCategory == "Product List Page" || pageInfo.pageCategory == "Site Search") {
				if (prodholder && typeof productData.product != undefined) {
					if (productData.page > 1) {
						prodholder = prodholder.concat(productData.product);
					} else {
						prodholder = prodholder[0].concat(productData.product);
					}

					for (var i = 0; i < prodholder.length; i++) {
						prodholder[i].position = i + 1;
					}
					for (var a = 0; a < productData.product.length; a++) {
						var diff = productData.product.length - a;
						productData.product[a].position = (prodholder.length - diff) + 1;
					}
					pushToDataLayer({
						"event": "eeListView",
						"eeAction": "eeListView",
						"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
						"dropDown": "",
						"filterChoice": "",
						"currencyCode": currencyCode,
						"products": productData.product || new Array()
					});
				}
			}

		})

		.on("swipe", ".product-slick-track", function (e, slick, direction) {
			var isDesktop = window.matchMedia("(min-width: 1025px)").matches;
			if(!isDesktop && direction == "left"){
				e.preventDefault();
				var $productTile = $(this).parents(".product-tile");
				var selectedImageId = parseInt($(this).find(".slick-track .slick-current").attr("data-slick-index")) + 1; 
				pushToDataLayer({
					"event": "PLPInteractions",
					"productName": getProductNamePLP($productTile),
					"productId": getProductIdPLP($productTile),
					"interactionType":  "Image Change",
					"imageSelection": selectedImageId,
					"sumImage": $(this).find(".slick-track .slick-slide").length
				});
			}
		})

		// tracking change on image - PLP
		.on("click", ".product-slick-track .slick-next", function (e) {
			var $productTile = $(this).parents(".product-tile");
			var selectedImageId = parseInt($(this).parents(".product-slick-track").find(".slick-track .slick-current").attr("data-slick-index")) + 1;   
			pushToDataLayer({
				"event": "PLPInteractions",
				"productName": getProductNamePLP($productTile),
				"productId": getProductIdPLP($productTile),
				"interactionType":  "Image Change",
				"imageSelection": selectedImageId,
				"sumImage": $(this).parents(".product-slick-track").find(".slick-track .slick-slide").length
			})
		})

		// tracking change on image
		.on("afterChange", ".pdp-product-thumbnail-slider, .product-images", function (e) {
			if($('#zoomProductImage') && !$('#zoomProductImage').is(':visible') && $('.pdp-redesign').length == 0) {
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"productName": getProductName(),
					"pageCategory": pageInfo.pageCategory,
					"productId": getProductID(),
					"interactionType": "Image Change"

				})
			}
			
		})
		
		.on("afterChange", ".pdp-redesign .product-images", function (e) {
			if($('.pdp-redesign').length > 0) {
				pushToDataLayer({
					"event": "productInteraction",
					"productName": getProductName(),
					"pageCategory": pageInfo.pageCategory,
					"productId": getProductID(),
					"interactionType" : "Image Change"
				})
			}
			
		})
		// click on next arrow recommendation carousel and best seller
		.on("click", ".pi .carousel-recommendations .slick-next", function (e) {
			if (typeof prodData != undefined && prodData != null) {
				var array = new Array();
				var listholder = new Array();
				var listchecker = false;
				var listctr = 0;
				$(".recommendation-item").each(function (index) {
					if ($(".recommendation-item").filter(".slick-active").length == 3) {
						if (index > 2 && $(this).hasClass("slick-active")) {
							array.push(index - 3);
						}
					} else {
						if (index > 2 && ($(this).hasClass("slick-active") || $(this).hasClass("slick-current"))) {
							listctr = 2;
							if (prodData.product.length > 3) {
								listchecker = true;
								listctr = 0;
							}
							array.push(index - 3);
						} else {
							if (listchecker && listctr < 2 && index > 2 && array.length <= 3) {
								if (array[array.length] != index - 3) {
									listctr += 1;
									array.push(index - 3);
								}
							} else {
								listchecker = false;
							}
						}

					}

				});
				for (var i = 0; i < prodData.product.length; i++) {
					for (var a = 0; a < array.length; a++) {
						if (i == array[a]) {
							listholder.push(prodData.product[i]);
						}
					}
				}
				pushToDataLayer({
					"currencyCode": currencyCode,
					"eeAction": "eeListView",
					"event": "eeListView",
					"pageCategory": pageInfo.pageCategory,
					"products": listholder
				});
			}
		})

		// click on prev arrow recommendation carousel and best seller
		.on("click", ".pi .carousel-recommendations .slick-prev", function (e) {
			if (typeof prodData != undefined && prodData != null) {
				var array = new Array();
				var listholder = new Array();
				var listchecker = false;
				var listctr = 0;
				$(".recommendation-item").each(function (index) {
					if ($(".recommendation-item").filter(".slick-active").length == 3) {
						if (index > 2 && $(this).hasClass("slick-active")) {
							array.push(index - 3);
						}
					} else {
						if (index > 2 && ($(this).hasClass("slick-active") || $(this).hasClass("slick-current"))) {
							listctr = 2;
							if (prodData.product.length > 3) {
								listchecker = true;
								listctr = 0;
							}
							array.push(index - 3);
						} else {
							if (listchecker && listctr < 2 && index > 2 && array.length <= 3) {
								if (array[array.length] != index - 3) {
									listctr += 1;
									array.push(index - 3);
								}
							} else {
								listchecker = false;
							}
						}

					}

				});
				for (var i = 0; i < prodData.product.length; i++) {
					for (var a = 0; a < array.length; a++) {
						if (i == array[a]) {
							listholder.push(prodData.product[i]);
						}
					}
				}
				pushToDataLayer({
					"currencyCode": currencyCode,
					"eeAction": "eeListView",
					"event": "eeListView",
					"pageCategory": pageInfo.pageCategory,
					"products": listholder
				});
			}
		})

		// click on next arrow of einstein recommendations carousel
		.on("click", ".cross-sell #recommendation .slick-next", function (e) {
			var $einstienRecommendation = $('div[id^="cq_recomm_slot"] .recommendation-container #recommendation');
			if($einstienRecommendation.length) {
				trackEinsteinRecommendation($(this));
			}
		})

		// click on prev arrow of einstein recommendations carousel
		.on("click", ".cross-sell #recommendation .slick-prev", function (e) {
			var $einstienRecommendation = $('div[id^="cq_recomm_slot"] .recommendation-container #recommendation');
			if($einstienRecommendation.length) {
				trackEinsteinRecommendation($(this));
			}
		})

		// click on dots of einstein recommendations carousel
		.on("click", ".cross-sell #recommendation .slick-dots > li", function (e) {	
			var $einstienRecommendation = $('div[id^="cq_recomm_slot"] .recommendation-container #recommendation');
			if($einstienRecommendation.length) {
				trackEinsteinRecommendation($(this));
			}
		})

		// pdp fire when variation was change
		.on("gtvariationchange", function (e) {
			if (pageInfo.pageCategory == "Product Page") {
				if($('#pdp-swatches') && $('.selectable').hasClass('selected')) {
					var selectedProductColor = $('.swatches.color:not(.sticky-swatches) li.selected').first().attr('data-selectedcolor');
					var selectedDataVariantVal = $('.swatches.size:not(.sticky-swatches) li.selected').first().attr('data-selectedcolor');
					var selectedPrice = $('.price-sales meta').first().attr('content');
					var selectedVariation = "outofstock";
					sessionStorage.setItem('selectedVariantSize',selectedDataVariantVal);
					sessionStorage.setItem('selectedVariantsColor',selectedProductColor);
					pushToDataLayer({
					"eeAction": "eeProductDetail",
					"event": "eeProductDetail",
					"pageCategory": "Product Page",
					'products': [{
						"listType": sessionStorage.getItem('listType'),
						"listName": sessionStorage.getItem('listName'),
						"id": pdpdata.masterID,
						"productVariantID": pdpdata.master ? pdpdata.defalutvariant : pdpdata.ID,
						"category": pdpdata.catid,
						"price": pdpdata.pricing.sale ? pdpdata.pricing.sale ? selectedPrice : selectedPrice : pdpdata.pricing.minprice,
						"name": pdpdata.name,
						"brand": pdpdata.brand,
						"quantity": pdpdata.quantity,
						"size": selectedDataVariantVal ? selectedDataVariantVal : pdpdata.size,
						"subCategory": pdpdata.subcategory,
						"subSubCategory": pdpdata.subsubcategory,
						"productAutoReplen": pdpdata.productautoreplenish,
						"productOutOfStock": $('#pdp-swatches') && $('.unselectable').hasClass('selected') ? selectedVariation : pdpdata.productOutOfStock,
						"productColor": selectedProductColor ? selectedProductColor : pdpdata.productColor,
						"productType": "Product",
						"collectionName": pdpdata.customBrand,
						"productNumReviews": ($("#BVRRSummaryContainer").length > 0) ? $('#BVRRSummaryContainer span[itemprop="reviewCount"]').text():'',
						"productStarRating":($("#BVRRSummaryContainer").length > 0 )? $('#BVRRSummaryContainer span[itemprop="ratingValue"]').text():''
					}]
					})
				}
			}
		})

		// Variation change on product tile
		.on("gttilevariationchange", function (e) {
			pushToDataLayer({
				"event": "eeListClick",
				"pageCategory": pageInfo.pageCategory,
				'products': [{
					"listType": sessionStorage.getItem('listType'),
					"listName": sessionStorage.getItem('listName'),
					"id": tileVariantData.masterID,
					"productVariantID": tileVariantData.master ? tileVariantData.defalutvariant : tileVariantData.ID,
					"category": tileVariantData.catid,
					"price": tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice,
					"name": tileVariantData.name,
					"brand": tileVariantData.brand,
					"quantity": tileVariantData.quantity,
					"size": tileVariantData.size,
					"subCategory": tileVariantData.subcategory,
					"subSubCategory": tileVariantData.subsubcategory,
					"productAutoReplen": tileVariantData.productautoreplenish,
					"productOutOfStock": tileVariantData.productOutOfStock,
					"productColor": tileVariantData.productColor,
					"productType": "Product",
					"collectionName": tileVariantData.customBrand,
					"productNumReviews": tileVariantData.productNumReviews,
					"productStarRating": tileVariantData.productStarRating
				}]
			})

		})

		//PLP filter change
		.on("selectmenuchange change", ".top-filter select", function (event, ui) {
			pushToDataLayer({
				"event": "dropDownChoice",
				"dropDownType": event.target[0].label.trim(),
				"filterChoice": ui.item.label.trim(),
				"listType": listType(),
				"listName": $(".breadcrumbs-desk-only .breadcrumb").find(".bc-item .breadcrumb-element:last").text().trim() + ">" + ui.item.label.trim()
			});
		})

		// 	Sort By in Makeup in PLP 		
		.on("selectmenuchange change", ".sort-by select", function (event, ui) {
			pushToDataLayer({
				"event": "dropDownChoice",
				"dropDownType": "Sort By",
				"filterChoice": $.trim($(".sort-by select").find(":selected").text().replace(/[\t\n]+/g,' ')),
				"listType": listType(),
				"listName": $(".breadcrumbs-desk-only .breadcrumb").find(".bc-item .breadcrumb-element:last").text().trim() + ">" + $.trim($(".sort-by select").find(":selected").text().replace(/[\t\n]+/g,' '))
			});
		})

		// 	related articles	
		.on('click', '.related-article-sec .related-article-content', function (e) {
			pushToDataLayer({
				"event": "relatedArticle",
				"page": $(this).children('a').text().trim(),
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": $('.container .article-full-col h1').text().trim()
			});
		})

		// 	Article details product image click
		.on('click', '.article-content-section .product-tile .thumb-link', function (e) {
			var $productTile = $(this).parents(".product-tile");
			pushToDataLayer({
				"event": "shopTheArticle",
				"productName": $productTile.find('.product-name').text().trim(),
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": $('.container .article-full-col h1').text().trim()
			});
		})

		// 	Article details product name click
		.on('click', '.article-content-section .product-tile .name-link', function (e) {
			var $productTile = $(this).parents(".product-tile");
			pushToDataLayer({
				"event": "shopTheArticle",
				"productName": $productTile.find('.product-name').text().trim(),
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": $('.container .article-full-col h1').text().trim()
			});
		})

		// 	Article details product view details click	
		.on('click', '.article-content-section .product-tile .buy-button', function (e) {
			var $productTile = $(this).parents(".product-tile");
			pushToDataLayer({
				"event": "shopTheArticle",
				"productName": $productTile.find('.product-name').text().trim(),
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": $('.container .article-full-col h1').text().trim()
			});
		})

		.on('click', '.search-result-content .product-tile-wrapper.product-grid', function (e) {			
			if ($('.container .article-full-col h1').length < 1 && !$(this).parents().hasClass('regimenzone')) {
				pushToDataLayer({
					"event": "shopTheArticle",
					"productName": $(this).find('.product-name').text().trim(),
					"pageSubCategory": pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory
				});
			}
		}).on('click', '.regimenzone .product-tile  a.thumb-link, .regimenzone .product-tile a.name-link', function (e) {
			var $gtmProductTile = $(this).parents(".product-tile").find('.gtm-product-tile');
			var tileVariantData = $gtmProductTile.data('value');
			var position = $(".regimenzone .product-tile a.thumb-link").index($(this)) + 1;
			
			pushToDataLayer({
				"event": "eeListClick",
				"pageCategory": pageInfo.pageCategory,
				'products': [{
					"listType": "Skincare regimen",
					"listName": pageInfo.pageCategory,
					"list": pageInfo.pageCategory,
					"position" : position,
					"id": tileVariantData.masterID,
					"productVariantID": tileVariantData.master ? tileVariantData.defalutvariant : tileVariantData.ID,
					"category": tileVariantData.catid,
					"price": tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice,
					"name": tileVariantData.name,
					"brand": tileVariantData.brand,
					"quantity": $(this).parents(".product-tile").find('.quantity select').val(),
					"size": tileVariantData.size,
					"subCategory": tileVariantData.subcategory,
					"subSubCategory": tileVariantData.subsubcategory,
					"productAutoReplen": tileVariantData.productautoreplenish,
					"productOutOfStock": tileVariantData.productOutOfStock,
					"productColor": tileVariantData.productColor,
					"productType": "Product",
					"collectionName": tileVariantData.customBrand,
					"productNumReviews": tileVariantData.productNumReviews,
					"productOrderType": getProductOrederType(),
					"productStarRating": tileVariantData.productStarRating
				}]
			});
		})
		//Add to cart from various pages
		.on('click', '.product-tile-inner .add-to-cart, .product-add-to-cart', function (e) {
			const $gtmProductTile = $(this).parents(".product-tile").find('.gtm-product-tile');
			const tileVariantData = $gtmProductTile.data('value');
			
			postQuickShopEvents($(this));
			const crossSellClick = $(this).closest('.cross-sell').length > 0;
			const addToCart = $(this).parents().hasClass('regimenzone') ? "Add to Bag - Regimen" : pageInfo.pageCategory;
			const isDatatrigger = $('.plp-content-wrapper').length && quickViewEnabled ? false : true;
			if ((isDatatrigger && !crossSellClick)) {
			pushToDataLayer({
				"currencyCode": window.Resources.CURRENCY,
				"event": crossSellClick && !$(".pt_cart").length ? "open_quickview" : "addToCart",
				"addToCartType": addToCart,
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				'products': [{
					"id": tileVariantData.masterID,
					"productVariantID": tileVariantData.master ? tileVariantData.defalutvariant : tileVariantData.ID,
					"category": tileVariantData.catid,
					"price": tileVariantData.pricing ? tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice ? tileVariantData.pricing.minprice : null : null,
					"name": tileVariantData.name,
					"brand": tileVariantData.brand,
					"quantity": $(this).parents(".product-tile").find('.quantity select').val(),
					"size": tileVariantData.size,
					"subCategory": tileVariantData.subcategory,
					"subSubCategory": tileVariantData.subsubcategory,
					"productAutoReplen": tileVariantData.productautoreplenish,
					"productOutOfStock": tileVariantData.productOutOfStock,
					"productColor": tileVariantData.productColor,
					"productType": "Product",
					"collectionName": tileVariantData.customBrand,
					"productNumReviews": tileVariantData.productNumReviews,
					"productOrderType": getProductOrederType(),
					"productStarRating": tileVariantData.productStarRating
				}]
			});
		}
		else{
			if(!$('.plp-content-wrapper').length && quickViewEnabled){
				pushToDataLayer({
				"event": crossSellClick ? "open_quickview":'addToCart',
				"currencyCode": window.Resources.CURRENCY,
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
				"productId": tileVariantData.masterID,
				"productVariantID": tileVariantData.master ? tileVariantData.defalutvariant : tileVariantData.ID,
				"productCategory": tileVariantData.catid,
				"productName": tileVariantData.name,
				"productSubCategory": tileVariantData.subcategory,
				"productSubSubCategory": tileVariantData.subsubcategory,

				})
			}
		}
	})
	//click apple pay button 
		.on("click", ".adyen-checkout__applepay__button", function (e){
			pushToDataLayer({
				"event": "eeCheckoutOption",
				"checkoutStep": "1",
				"checkoutOption": "applepay"

			});
			
		})

		.on('click','.cart-paypal-specific-popin .paypal-wrapper', function (e) {
			pushToDataLayer({
				'event' : 'popin_paypal_conditions_interaction',
				'interactionType' : 'popin_paypal_click_paypal'
			});		
		})

		.on('click','.cart-paypal-specific-popin #googlepay-container button', function (e) {
			pushToDataLayer({
				'event' : 'popin_googlepay_conditions_interaction',
				'interactionType' : 'popin_googlepay_click_googlepay'
			});		
		})

		//Click Fast checkout button of Applepay on Cart page
		.on("click", ".adyen-checkout__applepay__button", function (e){
			pushToDataLayer({
				"event": "checkoutType",
				"fastCheckoutType": "Applepay"
			});
		}) 
		//Click Fast checkout button of Paypal on Cart page
		.on("click", ".button-cart-checkout.paypal-button", function (e){			
			pushToDataLayer({
				"event": "checkoutType",
				"fastCheckoutType": "Paypal"
			})
		})
		
		.on("click", '.cart_container .cart-action-checkout .sticky', function (e){
			pushToDataLayer({
				"event": "eeCheckoutOption",
				'checkoutStep' : '1',
  				'checkoutOption' : "classic checkout" 
			})
		})

		.on("click", '.cart-action-checkout .sticky-redesign', function (e){
			pushToDataLayer({
				"event": "eeCheckoutOption",
				'checkoutStep' : '1',
  				'checkoutOption' : "classic checkout" 
			})
		})
		
	// PLP filter click 
	.on('click', "li.filter-option", function (e) {		
		if(!$(this).hasClass("selected")){			
			var filterSelection = $.trim($(this).closest('div.filter').find('.filter-heading').text().replace(/[\t\n]+/g,' '));
			var filterDetailsSelection = $(".seected-refinements-list li").map(function() {
			    return $.trim(this.innerText.replace(/[\t\n]+/g,' '));
			}).get();
			
			filterDetailsSelection = filterDetailsSelection.toString();
			filterDetailsSelection = filterDetailsSelection != '' ? filterDetailsSelection+","+$.trim($(this).text().replace(/[\t\n]+/g,' ')) : $.trim($(this).text().replace(/[\t\n]+/g,' '));
		
			pushToDataLayer({
				 "event": searchItems.search ? "searchInteractions" : "PLPInteractions",
				"pageSubCategory": pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory,
				"interactionType":"filter",
				"filterSelection" : filterSelection.toString(),
				"filterDetailsSelection" : filterDetailsSelection
			});
		}		
			
		})// on click search href - navigation
		.on('click', '.search-top-wrapper .category-tab-links li a', function (e) {
			gtmNavData = $(this).text().trim();
			var rep = gtmNavData.replace(/\n/g, " ");
			sessionStorage.setItem("navlink", rep.replace(/ +/g, " "));
			sessionStorage.setItem("menuloc", "site search submenu");			
			if($(this).attr("class") != undefined && $(this).attr("class") == 'highlighted') return;
			
			sessionStorage.setItem('searchNavValue',$.trim($(this).find('span').first().text().replace(/[\t\n]+/g,' ')));
			
		})//mobile grid click
		.on('click', ".grid-switch-wrapper button, .refinement, .clear-all-filter",function(e){
			pushToDataLayer({
				  "event": searchItems.search ? "searchInteractions" : "PLPInteractions",
				  "pageSubCategory": pageInfo.pageSubCategory,
				   "pageCategory": pageInfo.pageCategory,	
				  "interactionType": $(this).attr('id') == 'grid-view' ? 'view grid' : 'view unit',
				  "filterSelection": '',
				  "filterDetailsSelection": ''
				})
		})// Variation change on product tile
		.on('click',".tile-size-carousel a, .tile-color-carousel a", function (e) {
		pushToDataLayer({
			"eeAction": "eeProductDetail",
			"event": "eeProductDetail",
			"pageCategory": "Product Page",
			'products': [{
				"listType": sessionStorage.getItem('listType'),
				"listName": sessionStorage.getItem('listName'),
				"id": tileVariantData.masterID,
				"productVariantID": tileVariantData.master ? tileVariantData.defalutvariant : tileVariantData.ID,
				"category": tileVariantData.catid,
				"price": tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice,
				"name": tileVariantData.name,
				"brand": tileVariantData.brand,
				"quantity": tileVariantData.quantity,
				"size": tileVariantData.size,
				"subCategory": tileVariantData.subcategory,
				"subSubCategory": tileVariantData.subsubcategory,
				"productAutoReplen": tileVariantData.productautoreplenish,
				"productOutOfStock": tileVariantData.productOutOfStock,
				"productColor": tileVariantData.productColor,
				"productType": "Product",
				"collectionName": tileVariantData.customBrand,
				"productNumReviews": tileVariantData.productNumReviews,
				"productStarRating": tileVariantData.productStarRating
			}]
		})
		
		pushToDataLayer({
			"event": "productInteraction",
			"productCategory": getProductCategory(),
			"productSubCategory": getProductsubCategory(),
			"productName": getProductName(),
			"pageCategory": pageInfo.pageCategory,
			"productId": getProductID(),
			"interactionType": $(this).hasClass('size') ? 'choice of size' : 'choice of shade'
		})

	}) // Bambuser 
	.on('click',".bambuser-replay-wrapper .bambuser-thumbnail, .bambuser-replay-wrapper .bambuser-description", function (e) {	
		pushToDataLayer({
			"event": "productInteraction",
			"productName": getProductName(),
			"pageCategory": pageInfo.pageCategory,
			"productId": getProductID(),
			"interactionType" : "bambuser_replay_click"
		})
	})
	
	.on('click', '#pdpMain .custom-dd-list li', function () {
		var $this = $(this);
		const variantData = $('#pdpMain').find('.color-filter-wrapper li').filter(function() {
			return $(this).data('selectedcolor') == $this.attr('data-value');
		});
		pushToDataLayer({
			"event": "productInteraction",
			"interactionType": "select_shade_selector",
			"productCategory": $(".breadcrumb").find(".breadcrumb-element span").html(),
			"productSubCategory": $(".breadcrumb").find(".breadcrumb-element:eq(1) span").html(),
			"productName": getProductName(),
			"id": getProductID(),
			"productVariantID": variantData.find('.swatchanchor').data('pid'),
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory
		});
	})

	//paypal consent sheet
	.on('change','.cart-paypal-specific-popin input[type="checkbox"]', function (e) {	
		const isGpay = $('#googlepay-container').find('div').length > 0;
		const isPayPal = $('#paypal-container').find('div').length > 0;
		let interactionPayment;

		// Determine the interactionPayment based on the payment method
		if (isGpay) {
		interactionPayment = $(this).hasClass('newsletteroptinconsent') 
			? 'popin_googlepay_tick_newsletter' 
			: 'popin_googlepay_tick_conditions';
		} else if (isPayPal) {
		interactionPayment = $(this).hasClass('newsletteroptinconsent') 
			? 'popin_paypal_tick_newsletter' 
			: 'popin_paypal_tick_conditions';
		}

		if(this.checked){
			pushToDataLayer({
				'event' : isGpay ? 'popin_googlepay_conditions_interaction' : 'popin_paypal_conditions_interaction',
				'interactionType' : interactionPayment,
			});
        }		
	})

	.on('click', ".minicart-recommendation-container .product-info-text, .minicart-recommendation-container .thumb-link" , function (e) {
		e.stopPropagation();
		let tileVariantData = $(this).closest('.minicart-recommendations-tile').find('.gtm-product-tile').data('value');
		let products = [];
		let productdetails = {};
		let position;
		let $tile = $(this).closest('.minicart-recommendations-tile');

		if ($tile.length) {
			position = $tile.index() + 1;  // Ensures position is relative to the correct parent
		}
		productdetails.listType = 'Einstein';
		productdetails.listName = 'Minicart';
		productdetails.name = tileVariantData.name;
		productdetails.id = tileVariantData.masterID ? tileVariantData.masterID : tileVariantData.ID;
		productdetails.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
		productdetails.brand = tileVariantData.brand;
		productdetails.category = tileVariantData.catid;
		productdetails.position = position;
		productdetails.productAutoReplen = tileVariantData.productautoreplenish;
		productdetails.productOutOfStock = tileVariantData.productOutOfStock;
		productdetails.productColor = tileVariantData.productColor;
		productdetails.productType = "Product";
		productdetails.collectionName = tileVariantData.customBrand;
		productdetails.productNumReviews = tileVariantData.productNumReviews;
		productdetails.productStarRating = tileVariantData.productStarRating;
		productdetails.productOrderType = getProductOrederType();
		productdetails.productVariantID = tileVariantData.masterID ? tileVariantData.ID : null;
		productdetails.productBundle = tileVariantData.bundle;
		products.push(productdetails);
		
		pushToDataLayer({
			"pageSubCategory": pageInfo.pageSubCategory,
			"event": "eeListClick",
			"pageCategory": pageInfo.pageCategory,
			'products': products
		});
	})

	.on('click', ".minicart-recommendation-container .minicart-recommendations-tile .add-to-cart" , function (e) {
		e.stopPropagation();
		let tileVariantData = $(this).closest('.minicart-recommendations-tile').find('.gtm-product-tile').data('value');
		let products = [];
		let productdetails = {};
		let $tile = $(this).closest('.minicart-recommendations-tile');

		productdetails.name = tileVariantData.name;
		productdetails.id = tileVariantData.masterID ? tileVariantData.masterID : tileVariantData.ID;
		productdetails.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
		productdetails.brand = tileVariantData.brand;
		productdetails.quantity = tileVariantData.quantity;
		productdetails.size = tileVariantData.size;
		productdetails.category = tileVariantData.catid;
		productdetails.subCategory = tileVariantData.subcategory;
		productdetails.subSubCategory = tileVariantData.subsubcategory;
		productdetails.productAutoReplen = tileVariantData.productautoreplenish;
		productdetails.productOutOfStock = tileVariantData.productOutOfStock;
		productdetails.productColor = tileVariantData.productColor;
		productdetails.productType = "Product";
		productdetails.collectionName = tileVariantData.customBrand;
		productdetails.productNumReviews = tileVariantData.productNumReviews;
		productdetails.productStarRating = tileVariantData.productStarRating;
		productdetails.productOrderType = getProductOrederType();
		productdetails.productVariantID =  tileVariantData.masterID ? tileVariantData.ID : null;
		productdetails.productBundle = tileVariantData.bundle;
		products.push(productdetails);
		
		pushToDataLayer({
			"currencyCode": currencyCode,
			"pageSubCategory": pageInfo.pageSubCategory,
			"event": "addToCart",
			"addToCartType": "Add to Bag - Einstein - Minicart",
			"pageCategory": pageInfo.pageCategory,
			'products': products
		});
	})

.on('click', '.product-compare-wrapper  .thumb-link, .product-compare-wrapper .bv_stars_button_container, .product-compare-wrapper .bv_sub_container, .product-compare-wrapper .product-compare-view-btn', function(e){
    const $this = $(this);
    const $compareItem = $this.closest('.product-compare-item');
    const index = $compareItem.index();
    const tileVariantDataArr = window.compareProdData.product;
    const productsList = [];
    let count = 1;

    // push only the clicked product
    if (Array.isArray(tileVariantDataArr) && tileVariantDataArr.length > index) {
        const tileVariantData = tileVariantDataArr[index];
        const productdetails = {};
        productdetails.listType = "Product Compare";
        productdetails.listName = "Product Page";
        productdetails.position = count++;
        productdetails.brand = tileVariantData.brand;
        productdetails.category = tileVariantData.category;
        productdetails.categoryID = tileVariantData.categoryID;
        productdetails.collectionName = tileVariantData.collectionName; 
        productdetails.color = tileVariantData.color;
        productdetails.id = tileVariantData.id;
        productdetails.name = tileVariantData.name;
        productdetails.price = tileVariantData.price;
        productdetails.productColor = tileVariantData.productColor; 
        productdetails.productNumReviews = tileVariantData.productNumReviews;
        productdetails.productOutOfStock = tileVariantData.productOutOfStock; 
        productdetails.productStarRating = tileVariantData.productStarRating;
        productdetails.productType = tileVariantData.productType;
        productdetails.productVariantID = tileVariantData.productVariantID; 
        productdetails.size = tileVariantData.size;
        productdetails.subCategory = tileVariantData.subCategory; 
        productdetails.subCategoryID = tileVariantData.subCategoryID;
        productdetails.subSubCategory = tileVariantData.subSubCategory; 
        productdetails.subSubCategoryID = tileVariantData.subSubCategoryID; 
        productdetails.variant = tileVariantData.variant;
        productsList.push(productdetails);
    }

    pushToDataLayer({
        "currencyCode": currencyCode,
        "event": "eeListClick",
        "pageCategory": pageInfo.pageCategory,
        "pageSubCategory": pageInfo.pageSubCategory,
        "products": productsList
    });
})
	.on('click', '.pdp-faq-container .question-accordion', function (e) { // FAQ question click
		const $this = $(this);

		if($this.attr('aria-expanded') === 'true') {
			const productData = window.productCache || {};
			const productId = productData.masterID || productData.ID || '';
			const productVariantID = productData.ID || '';
			const productName = productData.name || '';
			const productSubCategory = productData.subcategory || '';

			pushToDataLayer({
				"event": "click_faq_question",
				"interactionType": $this.parent('.question-container').find('h3').text().trim(),
				"productCategory": getProductCategory(),
				"productSubCategory": productSubCategory,
				"productName": productName,
				"id": productId,
				"productVariantID": productVariantID,
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory,
			});
		}
	})
	
	// collection page view product click
	.on('click', '.pt_collectionrange .btn-view-product', function () {
		pushToDataLayer({
			"event": "view_product_collection_page",
			"productName": $(this).closest('.review-card').find('.review-card__title').first().text().trim()
		});
	})
	
	// collection page view product click
	.on('click', '.pt_collectionrange .star-product__button', function () {
		pushToDataLayer({
			"event": "view_product_collection_page",
			"productName": $(this).closest('.star-product__content-wrapper').find('.star-product__title a').text().trim()
		});
	})

	// Scroll on reviews in pdp
	$(window).on("scroll", function () {	//regimen section on scroll		
		if (($(".regimenzone").find(".regimen-bg").length) > 0) {
			var result = isScrolledIntoView(".regimen-bg");
			if(result[0] && unbindReg < 1) {
				unbindReg = 1;
				var $regimenbg =  $(".regimenzone").find(".regimen-bg");
				var productsList = [];
				var count = 1;
				$regimenbg.find('.gtm-product-tile').each(function () {
					var product = {};
					
					var tileVariantData = $(this).data('value');
					product.listType = "Skincare regimen";
					product.listName = pageInfo.pageCategory;
					product.list = pageInfo.pageCategory;
					product.position = count++;
					product.ID = tileVariantData.masterID || tileVariantData.ID;
					product.productVariantID = tileVariantData.ID;
					product.category = tileVariantData.catid;
					product.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
					product.name = tileVariantData.name;
					product.brand = tileVariantData.brand;
					product.quantity = productCache.productSet ? $("#quantity").val() : tileVariantData.quantity;
					product.size = tileVariantData.size;
					product.subCategory = tileVariantData.subcategory;
					product.subSubCategory = tileVariantData.subsubcategory;
					product.productAutoReplen = tileVariantData.productautoreplenish;
					product.productOutOfStock = tileVariantData.productOutOfStock;
					product.productColor = tileVariantData.productColor;
					product.productType = "Product";
					product.collectionName = tileVariantData.customBrand;
					product.productNumReviews = tileVariantData.productNumReviews;
					product.productStarRating = tileVariantData.productStarRating;
					product.productOrderType = getProductOrederType();
					productsList.push(product);
				});
				
				pushToDataLayer({
					"currencyCode": currencyCode,
					"eeAction": "eeListView",
					"event": "eeListView",
					"pageCategory": pageInfo.pageCategory,
					"products": productsList
				});
			}
		}
		
		if (($(".rating-review-container").length) > 0) {
			var result = isScrolledIntoView(".rating-review-container");
			if(result[0] && unbind < 1) {
				unbind = 1;
				pushToDataLayer({
					event: "productReviewsView",
					page: window.location.pathname,
					productCategory: getProductCategory(),
					productName: getProductName(),
					pageCategory: pageInfo.pageCategory,
					pageSubCategory: pageInfo.pageSubCategory
				});
			}
		}

		// for einstein recommendation in pdp and cart, Best Seller and Recently Viewed in Homepage
		if (($(".pi #recommendation").length > 0 || $(".cross-sell #recommendation").length > 0) && !$('.pt_collectionrange .cross-sell-wrapper').length) {
			$('#recommendation').each(function () {
				var result = isScrolledIntoView($(this));
				if (result[0]) {
					if (result[1] === 'recently-viewed cross-sell rv-section') {
						if (unbindreccarousel < 1) {
							unbindreccarousel = 1;
							pushToDataLayer({
								"currencyCode": currencyCode,
								"eeAction": "eeListView",
								"event": "eeListView",
								"pageCategory": pageInfo.pageCategory,
								"products": window.recentforpageload.product
							});
						}
					} else if (result[1] === '#recommendation cross-sell' && $('div[id^="cq_recomm_slot"] .recommendation-container #recommendation').length) {
						if (unbindEinsteinCarousel < 1) {
							unbindEinsteinCarousel = 1;
							trackEinsteinRecommendation($(this));
						}
					} else if (result[1].indexOf('pdp-social-media-section') == -1) {
						if (unbindcarousel < 1) {
							unbindcarousel = 1;
						if(SitePreferences.GTM_ENABLED)
	                    {
							pushToDataLayer({
								"currencyCode": currencyCode,
								"eeAction": "eeListView",
								"event": "eeListView",
								"pageCategory": pageInfo.pageCategory,
								"products": window.forpageload.product
							});
						}
						}
					}
				}
			});
		}

		// for product compare section
		if ($("#product-compare").length > 0) {
			var result = isScrolledIntoView("#product-compare");
			if (result[0] && unbindCompare < 1) {
				unbindCompare = 1;

				const $compareItems = $('.product-compare-item');
				const tileVariantDataArr = window.compareProdData.product;
				const productsList = [];
				let count = 1;

				//2 for mobile, 4 for desktop
				let maxItems = $(window).width() <= 768 ? 2 : 4;

				if (Array.isArray(tileVariantDataArr)) {
					$compareItems.each(function (i) {
						if (i >= maxItems) return false; // break after maxItems
						if (tileVariantDataArr[i]) {
							const tileVariantData = tileVariantDataArr[i];
							const productdetails = {};
							productdetails.listType = "Product Compare";
							productdetails.listName = "Product Page";
							productdetails.position = count++;
							productdetails.brand = tileVariantData.brand;
							productdetails.category = tileVariantData.category;
							productdetails.categoryID = tileVariantData.categoryID;
							productdetails.collectionName = tileVariantData.collectionName;
							productdetails.color = tileVariantData.color;
							productdetails.id = tileVariantData.id;
							productdetails.name = tileVariantData.name;
							productdetails.price = tileVariantData.price;
							productdetails.productColor = tileVariantData.productColor;
							productdetails.productNumReviews = tileVariantData.productNumReviews;
							productdetails.productOutOfStock = tileVariantData.productOutOfStock;
							productdetails.productStarRating = tileVariantData.productStarRating;
							productdetails.productType = tileVariantData.productType;
							productdetails.productVariantID = tileVariantData.productVariantID;
							productdetails.size = tileVariantData.size;
							productdetails.subCategory = tileVariantData.subCategory;
							productdetails.subCategoryID = tileVariantData.subCategoryID;
							productdetails.subSubCategory = tileVariantData.subSubCategory;
							productdetails.subSubCategoryID = tileVariantData.subSubCategoryID;
							productdetails.variant = tileVariantData.variant;
							productsList.push(productdetails);
						}
					});
				}

				pushToDataLayer({
					"currencyCode": currencyCode,
					"eeAction": "eeListView",
					"event": "eeListView",
					"pageCategory": pageInfo.pageCategory,
					"products": productsList
				});
			}
		}

		// for PDP REgimen view
		if ($(".pdp-routine-feature").length > 0 && unbindMVP == 0) {
			let resultMVP = isScrolledIntoView(".pdp-routine-feature");
			if(resultMVP[0] && unbindMVP < 1) {
				unbindMVP = 1;
				pdpRegimenListGtm();
			}		
		}
		
		if ($(".plp-cross-sell").length > 0) {
			const result = isScrolledIntoView(".plp-cross-sell");
			if (result && unbindRecomm < 1) {
				unbindRecomm = 1;
				
				pushToDataLayer({
					"currencyCode": currencyCode,
					"eeAction": "eeListView",
					"event": "eeListView",
					"pageSubCategory": pageInfo.pageSubCategory,
					"pageCategory": pageInfo.pageCategory,
					"products": crosssellProducts($(".plp-cross-sell").find('.recommendation-item'), "Einstein", "Product List Page")
				});
			}
		}
	})
	
	$(".product-listing").on('click',".btn-flat-black.back-to-top", function (e) {//back to top	
		pushToDataLayer({
			"event": "stickyNavigationTop",			
			"pageCategory":  searchItems.search ? "Site Search" : "Product List Page",
			"pageSubCategory": ""
		});
	});
	
	$(".cross-section").on("click", function() {
		pushToDataLayer({
			"event": "list_crossnav_interaction",			
			"list_subcategory":  $(this).find('.cross-tag-name').html().trim()
		});
	});
	
	$(".plp-cross-sell .recommendation-item .thumb-link, .plp-cross-sell .recommendation-item .pdp-link, .plp-cross-sell .recommendation-item .name-link").on("click", function() {
		pushToDataLayer({
			"currencyCode": currencyCode,
			"eeAction": "eeListClick",
			"event": "eeListClick",
			"pageSubCategory": pageInfo.pageSubCategory,
			"pageCategory": pageInfo.pageCategory,
			"products": crosssellProducts($(this).closest('.recommendation-item'), "Einstein", "Product List Page")
		});
	});

	// Track einstein recommendation on page load event
	trackEinsteinRecommendationOnLoad();
	
	// Track recommendation on collection page
	collectionPageCrosssellafterInit();
	collectionPageCrosssellClick();
	
	// Track cart Switch Size Upsell display
	setTimeout(function() {
		if ($('.promo-refill-offer').length) {
			pushToDataLayer({
				"event": "impression_cart_switch_size_upsell",
				"pageCategory": pageInfo.pageCategory,
				"pageSubCategory": pageInfo.pageSubCategory
			});
		}
	}, 500);
}

function minicartCrossSellafterInit($recommendations) {
	$recommendations
	.off('afterChange.minicartCrossSell')
	.on('afterChange.minicartCrossSell', function () {
		util.getTrulyVisibleSlides($recommendations).then(() => {
			minicartCrossSellProductList();
		});
	});
}

function minicrosssellPDPonInit($minicrossSellRecommendations) {
	$minicrossSellRecommendations.on('init', function () {
		util.getTrulyVisibleSlides($minicrossSellRecommendations).then(() => {
			pdpCrosssellList($minicrossSellRecommendations);
		});
	});
}

function minicrosssellPDPafterInit($minicrossSellRecommendations) {
	$minicrossSellRecommendations.on('afterChange', function () {
		util.getTrulyVisibleSlides($minicrossSellRecommendations).then(() => {
			pdpCrosssellList($minicrossSellRecommendations);
		});
	});

	$(window).on('resize', () => {
		setTimeout(() => {
			util.getTrulyVisibleSlides($minicrossSellRecommendations).then(() => {
				pdpCrosssellList($minicrossSellRecommendations);
			});
		}, 100);
	});
	
	$minicrossSellRecommendations.on('click',".pdp-link", function () {
		pushToDataLayer({
			"event": "eeListClick",
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"products": crosssellProducts($(this).closest('.slick-slide'), "Einstein", "Top Product Page")
		});
	});
}

function pdpCrosssellList($container) {
	pushToDataLayer({
		"currencyCode": currencyCode,
		"eeAction": "eeListView",
		"event": "eeListView",
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"products": crosssellProducts($container.find('.slick-slide.truly-visible'), "Einstein", "Top Product Page")
	});
}

function crosssellProducts($productListItems, $productListType, $productListName) {
	let productsList = [];
	$productListItems.find('.product-tile').each(function () {
		let product = {};
		const tileVariantData = $(this).find('.gtm-product-tile').data('value');
		if (!tileVariantData) return;
		product.listType = $productListType;
		product.listName = $productListName;
		product.position = $(this).closest('.slick-slide').data('slick-index') + 1;
		product.id = tileVariantData.masterID ? tileVariantData.masterID : tileVariantData.ID;
		product.productVariantID = tileVariantData.ID;
		product.category = tileVariantData.catid;
		product.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
		product.name = tileVariantData.name;
		product.brand = tileVariantData.brand;
		product.size = tileVariantData.size;
		product.subCategory = tileVariantData.subcategory;
		product.subSubCategory = tileVariantData.subsubcategory;
		product.productAutoReplen = tileVariantData.productautoreplenish;
		product.productOutOfStock = tileVariantData.productOutOfStock;
		product.productColor = tileVariantData.productColor;
		product.productType = "Product";
		product.collectionName = tileVariantData.customBrand;
		product.productBundle = tileVariantData.bundle;
		productsList.push(product);
	})
	return productsList;
}

function gymsharkCrosssellafterInit($gymsharkCrossSellRecommendations) {
	gymsharkCrosssellList($gymsharkCrossSellRecommendations);
	$gymsharkCrossSellRecommendations.on('click',".thumb-link, .product-link", function () {
		pushToDataLayer({
			"event": "eeListClick",
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"products": gymsharkProducts($(this).closest('.crosssell-recommendations-tile'))
		});
	});
}

function gymsharkCrosssellList($container) {
	let $productListItems = $container.find('.slick-active .crosssell-recommendations-tile').length ? $container.find('.slick-active .crosssell-recommendations-tile') : $container.children('.crosssell-recommendations-tile');
	pushToDataLayer({
		"currencyCode": currencyCode,
		"eeAction": "eeListView",
		"event": "eeListView",
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"products": gymsharkProducts($productListItems)
	});
}

function gymsharkProducts($productListItems) {
	let productsList = [];
	$productListItems.each(function () {
		let product = {};
		const tileVariantData = $(this).find('.gtm-product-tile').data('value');
		product.listType = "Gymshark";
		product.listName = "Minicart";
		product.position =  parseInt($(this).data('position'), 10);
		product.id = tileVariantData.masterID ? tileVariantData.masterID : tileVariantData.ID;
		product.productVariantID = tileVariantData.ID;
		product.category = tileVariantData.catid;
		product.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
		product.name = tileVariantData.name;
		product.brand = tileVariantData.brand;
		product.size = tileVariantData.size;
		product.subCategory = tileVariantData.subcategory;
		product.subSubCategory = tileVariantData.subsubcategory;
		product.productAutoReplen = tileVariantData.productautoreplenish;
		product.productOutOfStock = tileVariantData.productOutOfStock;
		product.productColor = tileVariantData.productColor;
		product.productType = "Product";
		product.collectionName = tileVariantData.customBrand;
		product.productBundle = tileVariantData.bundle;
		productsList.push(product);
	})
	return productsList;
}

/*
 * datalayer for Search Overlay
 */

function searchOverlayShow () {
		pushToDataLayer({
			event: 'virtualPageview',
			navigationLocationClicked: 'search overlay',
			websiteCountry: pageInfo.websiteCountry,
			language: pageInfo.language,
			pageSubCategory: pageInfo.pageSubCategory,
			pageCategory: pageInfo.pageCategory
		});
}

function googlePayTracking() {
	pushToDataLayer({
		'event' : 'popin_googlepay_conditions_interaction',
		'interactionType' : 'popin_googlepay_click_googlepay'
	});
}

function searchProductTile (event) {

	var $gtmProductTile = '';

	if ($('.search-redesign-container .popular-suggestion-container .einstein-recommender-wrapper').length > 0) {
		$gtmProductTile = $(event).closest(".product-tile-wrapper").next('.gtm-search-tile');
	} else {
		$gtmProductTile = $(event).closest(".product-tile-outer").next('.gtm-search-tile');
	}

	var tileVariantData = $gtmProductTile.data('value');

	pushToDataLayer({
		event: 'eeListClick',
		pageCategory: pageInfo.pageCategory,
		products: [
			{
				"id": tileVariantData.id,
				"name": tileVariantData.name,
				"price": tileVariantData.price,
				"category": tileVariantData.category,
				"collectionName": tileVariantData.collectionName,
				"subCategory": tileVariantData.subcategory,
				"subSubCategory": tileVariantData.subsubcategory,
				"productOutOfStock": tileVariantData.productOutOfStock,
				"color" : tileVariantData.productColor,
				"productColor": tileVariantData.productColor,
				"variant": tileVariantData.variant,
				"productAutoReplen": tileVariantData.productautoreplenish,
				"productType": tileVariantData.productType,
				"size": tileVariantData.size,
				"productVariantID": tileVariantData.productVariantID,
				"listType": 'search overlay',
				"listName": tileVariantData.listName,
				"list": 'Search',
				"position": '',
				"quantity": tileVariantData.quantity,
			}
		]
	});
};

function searchCategoryLink (event) {
	let interactionType = '';
	let filterSelection = '';
	const $event = $(event);
	if($event.parents('.category-wrapper').length > 0){
		interactionType = 'Categories';
		// Create a regular expression to match both values
		var CategoryRegex = new RegExp('<strong>' + "|" + '</strong>', "g");
		// Use the `replace()` method to remove the matched values
		var resultString = $event.parent('.item').attr('data-category').replace(CategoryRegex, "");

		filterSelection = resultString;
	} else if($event.parents('.suggestion-wrapper').length > 0){
		interactionType = 'Suggestions';
		filterSelection = $event.html();
	} else if($event.parents('.popular-search-catergory').length > 0 && !$event.parents('.recent-search-cont').length > 0 ){
		interactionType = 'Popular searches'
		filterSelection = $event.parent('.item').attr('data-category');
	} else if($event.parents('.suggestion-header').length > 0){
		interactionType = 'view all'
	} 
	 else if ($event.parents('.recent-search-cont').length > 0) {
		interactionType = 'historical_searches'
	}

	pushToDataLayer({
		event: "search_overlay_interaction",
		overlayInteractionType: interactionType,
		filterSelection: filterSelection,
		pageCategory: pageInfo.pageCategory,
		pageSubCategory: pageInfo.pageSubCategory
	})
}

function paypalExpressDatalayer() {
	pushToDataLayer({
		'event' : 'popin_paypal_conditions_interaction',
		'interactionType' : 'popin_paypal_click_paypal'
	});
}

function searchEinstienProductList () {
	var productsList = [];
	var count = 1;
			for(var i = 0; i < searchProductData.product.length; i++) {
				var productlistdata = {
					"id": searchProductData.product[i].id,
					"name": searchProductData.product[i].name,
					"price": searchProductData.product[i].price,
					"category": searchProductData.product[i].category,
					"collectionName": searchProductData.product[i].collectionName,
					"subCategory": searchProductData.product[i].subcategory,
					"subSubCategory": searchProductData.product[i].subsubcategory,
					"productOutOfStock": searchProductData.product[i].productOutOfStock,
					"color" : searchProductData.product[i].productColor,
					"productColor": searchProductData.product[i].productColor,
					"variant": searchProductData.product[i].variant,
					"productAutoReplen": searchProductData.product[i].productAutoReplen,
					"productType": searchProductData.product[i].productType,
					"size": searchProductData.product[i].size,
					"productVariantID": searchProductData.product[i].productVariantID,
					"listType": 'search overlay',
					"listName": searchProductData.product[i].listName,
					"list": 'Search',
					"position": count++,
					"quantity": searchProductData.product[i].quantity,
				}
				productsList.push(productlistdata)
			}

			pushToDataLayer({
				event: "eeListView",
				eeAction: "eeListView",
				pageCategory: pageInfo.pageCategory,
				currencyCode: currencyCode,
				products: productsList
			});
}

/*
 * datalayer for news-letter popup
 */

function gtmNewsletterPopup(event, siteLocation) {
	// fire when news-letter popup toggles
    if ($(".newsletter-modal").length > 0 && event && siteLocation) {		
		pushToDataLayer({
			"event": event,
			"siteLocation": siteLocation,
			"pageSubCategory": pageInfo.pageSubCategory,
			"pageCategory": pageInfo.pageCategory
		});
    }
}

/**
 * google address click data layer
 * @returns
 */
function googleAddressTracking(){
	pushToDataLayer({	
		"event": "searchInteractions",
		"pageCategory": pageInfo.pageCategory,
		"interactionType" : "GoogleAutocomplete used",
	});
}

/*
 * Populate Search Suggestion
 */
function populateSearchSuggestion() {
	//push data after user stops for 2secs, search suggestion box
		  util.delay(function(){		  
			  if($('.suggestions-wrapper').length > 0){
				  
				  pushToDataLayer({
					  "event": "virtualPageview",
					  "pageError": "",
					  "navigationLocationClicked": "site search pop-in",
					  "navigationLinkClicked": 0,
					  "websiteCountry": pageInfo.websiteCountry,
					  "userId": window.User.customerNo,
					  "navigationLinkNameClicked": "",
					  "language": pageInfo.language,
					  "productUpdate": 0,
					  "pageSubCategory": pageInfo.pageSubCategory,
					   "pageCategory": pageInfo.pageCategory,						
					  "dropDown": "",
					  "filterChoice": ""
					});
			  }
		  }, 2000 );
		  
		  $('.suggestions-wrapper .product').on("click", function() {
					pushToDataLayer({
					  "event": "searchInteractions",
					  "pageSubCategory": pageInfo.pageSubCategory,
					   "pageCategory": pageInfo.pageCategory,	
					  "interactionType": "Click on Product",
					  "filterSelection": $.trim($(this).find('.parent-category').text().replace(/[\t\n]+/g,' ')),
					  "filterDetailsSelection": $.trim($(this).find('.product-name').text().replace(/[\t\n]+/g,' '))
					})
			})
			
			 $('.suggestions-wrapper .content').on("click", function() {
					pushToDataLayer({
					  "event": "searchInteractions",
					  "pageSubCategory": pageInfo.pageSubCategory,
					   "pageCategory":  pageInfo.pageCategory,	
					  "interactionType": "Click on Edits Tutorials",
					  "filterSelection": $.trim($(this).find('.parent-category').text().replace(/[\t\n]+/g,' ')),
					  "filterDetailsSelection": $.trim($(this).find('.content-name').text().replace(/[\t\n]+/g,' '))
					})
			})
}

function postQuickShopEvents(ele){
	var index = ele.parents(".gtmindex").index(".gtmindex");
	var pid = ele.parents(".product-tile").data("itemid");
	var masterPid = ele.parents(".product-tile").data("masterpid");
	var eventValue;
	var clickProduct = {};
	var tempProdData = {};

	if(typeof prodholder !== "undefined" && prodholder[0] && prodholder[0].length){
		tempProdData = prodholder[0];
		for(var i=0;i<tempProdData.length;i++){
			if(tempProdData[i].productVariantID == pid || tempProdData[i].id == pid){
				clickProduct = tempProdData[i];
				break;
			}
		}
	}

	if(clickProduct.length == undefined && typeof prodholder !== "undefined"){
		for(var i=0;i<prodholder.length;i++){
			if(prodholder[i].productVariantID == pid || prodholder[i].id == pid){
				clickProduct = prodholder[i];
				break;
			}
		}
	}

	if (pageInfo.pageCategory == "Product Page") {
		eventValue = "eeProductDetail";
	} else {
		eventValue = "eeListClick";
	}
	if(index >= 0){
		sessionStorage.setItem('listType', clickProduct.listType);
		sessionStorage.setItem('listName', clickProduct.listName);
		pushToDataLayer({
			"eeAction": eventValue,
			"event": eventValue,
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": "Quick shop mobile",
			'products': [clickProduct]
		})
		
		pushToDataLayer({
			  "event": "virtualPageview",
			  "pageError": "",
			  "navigationLocationClicked": "",
			  "navigationLinkClicked": "",
			  "websiteCountry": pageInfo.websiteCountry,
			  "userId": window.User.customerNo,
			  "navigationLinkNameClicked": '',
			  "language": pageInfo.language,
			  "productUpdate": 0,
			  "pageCategory": pageInfo.pageCategory,
			  "pageSubCategory": pageInfo.pageSubCategory,					
			  "dropDown": "",
			  "filterChoice": ""
			})
			if ($('.plp-content-wrapper').length && quickViewEnabled) {
			pushToDataLayer({
				"event" :"open_quickview",
				"pageSubCategory":pageInfo.pageSubCategory,
				"pageCategory": pageInfo.pageCategory,
				'productName':[clickProduct][0].name,
				'productId':masterPid,
				'productCategory':[clickProduct][0].category,
				'productSubCategory': [clickProduct][0].subCategory,
				'prodcutSubSubCategory':[clickProduct][0].subSubCategory,
			});
		}
	}
}

/*
*  datalayer to track recommendation carousel's click event next/prev
*/ 
function trackRecommendationClickEvent() {
	if (typeof prodData != undefined && prodData != null) {
		var array = new Array();
		var listholder = new Array();
		$(".recommendation-item").each(function (index) {
			if (index > 2 && $(this).hasClass("slick-active")) {
				array.push(index - 3);
			}
		});
		for (var i = 0; i < prodData.product.length; i++) {
			for (var a = 0; a < array.length; a++) {
				if (i == array[a]) {
					listholder.push(prodData.product[i]);
				}
			}
		}
		pushToDataLayer({
			"currencyCode": currencyCode,
			"eeAction": "eeListView",
			"event": "eeListView",
			"pageCategory": pageInfo.pageCategory,
			"products": listholder
		});
	}
}

/*
*  datalayer for Einstein recommendation
*/
function getEinsteinProducts(ele) {
	var recommendationCarousel = $('div[id^="cq_recomm_slot"] .recommendation-container #recommendation');
	var recommendationCarouselItems = recommendationCarousel.hasClass('slick-initialized') ? recommendationCarousel.find('.slick-slide.slick-active') : getNotInitEinsteinProducts(recommendationCarousel.find('.recommendation-slide'));
	var productData = (window.prodData != undefined && window.prodData != null) ? window.prodData.product : [];
	var products = [];
	if(recommendationCarouselItems.length && productData.length) {
		recommendationCarouselItems.each(function() {
			var $product = $(this).find('.product-tile');
			for(var i = 0; i < productData.length; i++) {
				if($product.length && productData[i].id == $product.data("masterpid")) {
					productData[i].listType = "Einstein";
					productData[i].list = $('.page-not-found-404').length > 0 ? "404 Page"  : ($(".no-search-text-wrapper").length > 0 ? "Site Search" : (pageInfo.pageCategory));
					productData[i].listName = $('.page-not-found-404').length > 0 ? "404 Page"  : ($(".no-search-text-wrapper").length > 0 ? "Site Search" : (pageInfo.pageCategory));
					products.push(productData[i])
				}
			}
		});
	}	
	return products;
}
function trackEinsteinRecommendation(ele) {
	var products = getEinsteinProducts(ele) || [];
	pushToDataLayer({
		"currencyCode": currencyCode,
		"eeAction": "eeListView",
		"event": "eeListView",
		"pageSubCategory": pageInfo.pageSubCategory, 
		"pageCategory": pageInfo.pageCategory,
		"products": products
	});
}
function getNotInitEinsteinProducts(elements) {
	var newElements = [];
	var winWidth = $(window).width();
	if(winWidth >= 1024 && elements.length) {
		newElements = (elements.length > 4) ? elements.slice(0, 4) : elements;
	} else if (winWidth >= 768 && winWidth < 1024 && elements.length) {
		newElements = (elements.length > 3) ? elements.slice(0, 3) : elements;
	} else if (winWidth > 480 && winWidth < 768 && elements.length) {
		newElements = (elements.length > 2) ? elements.slice(0, 2) : elements;
	} else if (winWidth < 480 && elements.length) {
		newElements = (elements.length > 1) ? elements.slice(0, 1) : elements;
	}
	return newElements;
}
/*
*  To track recommendation carousel's on page load event
*/ 
function trackEinsteinRecommendationOnLoad() {	
	// trigger when einstien Recomm loaded()
	setTimeout(function() {
		// track recommendation carousel in Homepage, PDP, no-search, cart and 404 page
		var $einstienRecommendation = $('div[id^="cq_recomm_slot"] .recommendation-container #recommendation');
		if ($einstienRecommendation.length) {
			var result = isScrolledIntoView($einstienRecommendation);
			if (result[0] && result[1] === 'recommendation-container cross-sell' && unbindEinsteinCarousel < 1) {
				unbindEinsteinCarousel = 1;
				trackEinsteinRecommendation();
			}
		}
	}, 5000)	
}

/*
*  To track Social login type on loggedinn
*/ 
function socialLoginEvent(socialId) {
	socialId = socialId.toLowerCase();
	
	var socialType = "Google";
	
	if(socialId.indexOf('apple') > -1){
		socialType = "Apple";
	}
	
	localStorage['socialLoginType'] = socialType;
}

//Gift Card Added to Cart
 function addBonusProductDataLayer(pids) {
	let refProd = typeof(basketConfirmation) != 'undefined' ? basketConfirmation.productLineItems : miniBasketConfirmation.productLineItems;
	if(pids && pids.length > 0){
		let pidsArr = pids.split(',');
		let finalProd = [];

		for (let i = 0; i < refProd.length; i++) {
			if( (pidsArr.includes(refProd[i].productVariantID) || pidsArr.includes(refProd[i].id)) && refProd[i].productType == 'Bonus Product'){
				finalProd.push(refProd[i]);
			}
		}

		pushToDataLayer({
			'event' : 'add_gwp_to_cart', 
			"addToCartType": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"pageCategory": pageInfo.pageCategory,
			"currencyCode": window.Resources.CURRENCY,
			"product" :finalProd
			});	

	}else{
	//Bonus product is added at the end
	let cartLineItem  = $('.js-cart-analytics').length;
	let index = cartLineItem - 1;

	pushToDataLayer({
		'event' : 'add_gwp_to_cart', 
		"addToCartType": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"pageCategory": pageInfo.pageCategory,
		"currencyCode": window.Resources.CURRENCY,
		"product" : {
			"id": refProd[index].id,
			"category": refProd[index].category,
			"price": refProd[index].price,
			"name": refProd[index].name,
			"brand": getProductBrand(),
			"quantity": refProd[index].quantity,
			"size": refProd[index].size,
			"subCategory": refProd[index].subCategory,
			"subSubCategory": refProd[index].subSubCategory,
			"productAutoReplen": refProd[index].productAutoReplen,
			"productOutOfStock": refProd[index].productOutOfStock,
			"productColor": refProd[index].productColor,
			"productType": refProd[index].productType,
			"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
			"productVariantID": refProd[index].productVariantID,
			"collectionName": refProd[index].collectionName
		}
		});	
	}	
}

function cartPaymentDataLayer(paymentMethod) {
	pushToDataLayer({
		"event": "eeCheckoutOption",
		"checkoutStep": "1",
		"checkoutOption": paymentMethod
	});
}

/*
* To track Video Player events
*/

function trackVideoPlayer(event) {
	var state = event.type;
	var player = this;
  
	var message = {
	  state: state,
	  videoName: player.mediainfo.name,
	};

	var videoName = message.videoName;
	var mutedValue = 'true';

	var pushOnce =0;
	var pushOnceProgress = 0;
	var pushOnceComplete = 0;
	//when video starts playing or when user plays the video by click
	$('video').on("play", function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		if(e.target.muted) {
			mutedValue = 'true';
		} else {
			mutedValue = 'false';
		}
		let videoLang = $(this).parent('.video-js').attr('lang');
		setTimeout(() => {
			pushToDataLayer({
				'event' : 'video_start',
				'video_title': videoName,
				'video_id' : $(this).attr('data-video-id'),
				'video_provider' :'BrightCove',
				'video_duration' : e.target.duration,
				'video_language' : videoLang,
				'video_muted' : mutedValue
			});
		}, 500);
	  });

	//when user mutes or unmutes a video
	$('video').on('volumechange',function(e){
		e.preventDefault();
		e.stopImmediatePropagation();
		let videoLang = $(this).parent('.video-js').attr('lang');
		if(e.target.muted) {
			mutedValue = 'true';
		} else {
			mutedValue = 'false';
		}
		pushToDataLayer({
			'event' : 'video_start',
			'video_title': videoName,
			'video_id' : $(this).attr('data-video-id'),
			'video_provider' :'BrightCove',
			'video_duration' : e.target.duration,
			'video_language' : videoLang,
			'video_muted' : mutedValue
		});
	});

	///When video reaches threshold of 30%
	  $('video').on("timeupdate", function (e) {
		e.stopImmediatePropagation();

		let videoLang = $(this).parent('.video-js').attr('lang');
		let videoPercentage = parseInt(e.target.currentTime*100/e.target.duration);

		if(videoPercentage < 30) {
			pushOnce =0;
			pushOnceProgress = 0;
			pushOnceComplete = 0;
		} else if(videoPercentage >= 30 && videoPercentage < 60) {
			if(pushOnce < 1) {
				setTimeout(() => {
					pushToDataLayer({
						'event' : 'video_progress',
						'video_title': videoName,
						'video_percent' : 30,
						'video_id' :  $(this).attr('data-video-id'),
						'video_provider' : 'BrightCove',
						'video_duration' : e.target.duration,
						'video_language' : videoLang,
					});		
				}, 200);
			}
			pushOnce+=1;//Reset for duplicates
		} else if (videoPercentage >= 60 && videoPercentage < 90) {
			if(pushOnceProgress < 1) {
				setTimeout(() => {
					pushToDataLayer({
						'event' : 'video_progress',
						'video_title': videoName,
						'video_percent' : 60,
						'video_id' :  $(this).attr('data-video-id'),
						'video_provider' : 'BrightCove',
						'video_duration' : e.target.duration,
						'video_language' : videoLang,
					});	
				}, 200);
			}
			pushOnceProgress+=1;
		} else if (videoPercentage >= 90 && videoPercentage <100) {
			if(pushOnceComplete < 1){
				setTimeout(() => {
					pushToDataLayer({
						'event' : 'video_complete',
						'video_title': videoName,
						'video_id' :  $(this).attr('data-video-id'),
						'video_provider' : 'BrightCove',
						'video_duration' : e.target.duration,
						'video_language' : videoLang,
					});
				},200);
			}
			pushOnceComplete+=1;
		}
	});

	//When user seeks i.e, drags the video to above 30%/60%/90% threshold
	$('video').on('seeked', function (e) {
		e.stopImmediatePropagation();
		pushOnce =0;
		pushOnceProgress =0;
		pushOnceComplete = 0;
		let videoLang = $(this).parent('.video-js').attr('lang');
		let videoPercentage = parseInt(e.target.currentTime*100/e.target.duration);
		if(videoPercentage < 30) {
			pushOnceComplete = 0;
			pushOnce =0;
			pushOnceProgress = 0;
		} else if(videoPercentage >= 30 && videoPercentage <=60) {
			if(pushOnce < 1) {
				setTimeout(() => {
					pushToDataLayer({
						'event' : 'video_progress',
						'video_title': videoName,
						'video_percent' : 30,
						'video_id' :  $(this).attr('data-video-id'),
						'video_provider' : 'BrightCove',
						'video_duration' : e.target.duration,
						'video_language' : videoLang,
					});		
				}, 200);
			}
			pushOnce+=1;//Reset for duplicates
		} else if (videoPercentage >= 60 && videoPercentage <=90) {
			if(pushOnceProgress < 1) {
				setTimeout(() => {
					pushToDataLayer({
						'event' : 'video_progress',
						'video_title': videoName,
						'video_percent' : 60,
						'video_id' :  $(this).attr('data-video-id'),
						'video_provider' : 'BrightCove',
						'video_duration' : e.target.duration,
						'video_language' : videoLang,
					});	
				}, 200);
			}
			pushOnceProgress+=1;
		} else if (videoPercentage >= 90 && videoPercentage <=100) {
			if(pushOnceComplete < 1){
				setTimeout(() => {
					pushToDataLayer({
						'event' : 'video_complete',
						'video_title': videoName,
						'video_id' :  $(this).attr('data-video-id'),
						'video_provider' : 'BrightCove',
						'video_duration' : e.target.duration,
						'video_language' : videoLang,
					});
				},200);
			}
			pushOnceComplete+=1;
		}
	})
}

  /**
   * @public
   * @param {int} numTries Counter of tries to check that players are valid.
   * @throws any error from Brightcove's `videojs` object.
   */
  function triggerVideoPlayer () {
	if(typeof(videojs) != 'undefined') {
		var players = videojs.getPlayers();
		var playerIds = Object.keys(players);
		// a Brightcove IFRAME can only include one player
		var playerId = playerIds[0];
		try {
			videojs.getPlayer(playerId).ready(function() {
			var player = this;
			player.on('loadstart', trackVideoPlayer);
			var playerEvents = [
				'ended',
				'loadeddata',
				'loadedmetadata',
				'pause',
				'play',
				'ready',
				'stalled',
				'timeupdate',
				'volumechange',
			  ];
			  playerEvents.forEach(function(playerEvent) {
				player.on(playerEvent, trackVideoPlayer);
			  });
			});
		} catch (e) {
			// use a warning, not an error, so that other scripts can run normally
		}
	}
  }

  triggerVideoPlayer();

	$(document).on('load scroll', function () {
		triggerVideoPlayer();
	});

//eeListView dataLayer upon display of a product of a cross-sell from the cross-sell minicart
function minicartCrossSellProductList() {
	if ($('.minicart-recommendation-container').length) {
		let $productListItems = $('.minicart-recommendation-container').find('.slick-slide.truly-visible');
		let productsList = [];
		$productListItems.each(function () {
			let product = {};
			const tileVariantData = $(this).find('.gtm-product-tile').data('value');
			product.listType = "Einstein";
			product.listName = "Minicart";
			product.list = pageInfo.pageCategory;
			product.position = $(this).data('slick-index') + 1;
			product.ID = tileVariantData.masterID ? tileVariantData.masterID : tileVariantData.ID;
			product.productVariantID = tileVariantData.masterID ? tileVariantData.ID : null;
			product.category = tileVariantData.catid;
			product.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
			product.name = tileVariantData.name;
			product.brand = tileVariantData.brand;
			product.quantity = tileVariantData.quantity;
			product.size = tileVariantData.size;
			product.subCategory = tileVariantData.subcategory;
			product.subSubCategory = tileVariantData.subsubcategory;
			product.productAutoReplen = tileVariantData.productautoreplenish;
			product.productOutOfStock = tileVariantData.productOutOfStock;
			product.productColor = tileVariantData.productColor;
			product.productType = "Product";
			product.collectionName = tileVariantData.customBrand;
			product.productNumReviews = tileVariantData.productNumReviews;
			product.productStarRating = tileVariantData.productStarRating;
			product.productOrderType = getProductOrederType();
			productsList.push(product);
		})

		pushToDataLayer({
			"currencyCode": currencyCode,
			"eeAction": "eeListView",
			"event": "eeListView",
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"products": productsList
		});
	}
};

//productInteraction dataLayer upon click of notify me button of Coming soon product
function notifyMeClick(productId) {
	pushToDataLayer({
		"event": "productInteraction",
		"productName": getProductName(),
		"pageCategory": pageInfo.pageCategory,
		"productId": productId,
		"interactionType" : "notify_product_availability"
	});
};

//Track upon click of refill offer button on cart page
function refillOfferClick(elem) {
	const index = $(elem.currentTarget).closest('.js-cart-analytics').index() - 1;
	pushToDataLayer({
		"event": "click_cart_switch_size_upsell",
		"productCategory": basketConfirmation.productLineItems[index].category,
		"productSubCategory": basketConfirmation.productLineItems[index].subCategory,
		"productName": basketConfirmation.productLineItems[index].name,
		"id": basketConfirmation.productLineItems[index].id,
		"productVariantID": basketConfirmation.productLineItems[index].productVariantID,
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory
	});
};

//eeListView dataLayer upon display of a product PDP regimen section
function pdpRegimenListGtm() {
	if ($('.pdp-routine-feature').length) {
		let $productListItems = $('.pdp-routine-feature').find('.gtm-product-regimen');
		let productsList = [];
		$productListItems.each(function (index) {
			let product = {};
			let tileVariantData = $(this).data('value');
			product.listType = "Skincare Regimen";
			product.listName = "Product Page";
			product.list = pageInfo.pageCategory;
			product.position = index + 1;
			product.brand = tileVariantData.brand;
			product.category = tileVariantData.category;
			product.categoryID = tileVariantData.categoryID;
			product.collectionName = tileVariantData.collectionName; 
			product.color = tileVariantData.color;
			product.id = tileVariantData.masterID;
			product.name = tileVariantData.name;
			product.price = tileVariantData.price;
			product.productColor = tileVariantData.productColor; 
			product.productNumReviews = tileVariantData.productNumReviews;
			product.productOutOfStock = tileVariantData.productOutOfStock; 
			product.productStarRating = tileVariantData.productStarRating;
			product.productType = tileVariantData.productType;
			product.productVariantID = tileVariantData.productVariantID; 
			product.size = tileVariantData.size;
			product.subCategory = tileVariantData.subCategory; 
			product.subCategoryID = tileVariantData.subCategoryID;
			product.subSubCategory = tileVariantData.subSubCategory; 
			product.subSubCategoryID = tileVariantData.subSubCategoryID; 
			product.variant = tileVariantData.variant;
			productsList.push(product);
		});

		pushToDataLayer({
			"currencyCode": currencyCode,
			"eeAction": "eeListView",
			"event": "eeListView",
			"pageCategory": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"products": productsList
		});
	}
};

function gtmRegimenQuickView(regimenVal, event){
	pushToDataLayer({
		"event": event,
		"currencyCode": window.Resources.CURRENCY,
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"productId": regimenVal.masterID || '',
		"productVariantID": regimenVal.productVariantID || regimenVal.ID,
		"productCategory": regimenVal.category || regimenVal.catid,
		"productName": regimenVal.name,
		"productSubCategory": regimenVal.subCategory || regimenVal.subcategory,
		"productSubSubCategory": regimenVal.subSubCategory || regimenVal.subsubcategory
		});
}

function regimenAddToCart(pids){
	const pidArr = Array.isArray(pids) ? pids : Array(pids);
	let $productListItems = $('.pdp-routine-feature').find('.gtm-added-regimen');	
	let productsList = [];
	let productdetails = {};

	$productListItems.each(function (index) {
		let tileVariantData = $(this).val();
		tileVariantData = tileVariantData != '' ? JSON.parse(tileVariantData) : {};
		let prodPrice = 0;
		let prodId = '';
		if( tileVariantData != ''){
			prodId = tileVariantData.ID || tileVariantData.id;
		}		
		
		if(tileVariantData != '' && pidArr.includes(prodId)){
			if('pricing' in tileVariantData){
				prodPrice = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;			
			}else{
				prodPrice = tileVariantData.price;
			}

			productdetails = {};
			productdetails.name = tileVariantData.name;
			productdetails.id = tileVariantData.masterID || '';
			productdetails.price = prodPrice;
			productdetails.brand = tileVariantData.brand;
			productdetails.quantity = tileVariantData.quantity;
			productdetails.size = tileVariantData.size;
			productdetails.category =  tileVariantData.category || tileVariantData.catid;
			productdetails.subCategory = tileVariantData.subCategory || tileVariantData.subcategory;
			productdetails.subSubCategory = tileVariantData.subSubCategory || tileVariantData.subsubcategor;
			productdetails.productAutoReplen = tileVariantData.productautoreplenish;
			productdetails.productOutOfStock = tileVariantData.productOutOfStock;
			productdetails.productColor = tileVariantData.productColor;
			productdetails.productType = "Product";
			productdetails.collectionName = tileVariantData.customBrand;
			productdetails.productNumReviews = tileVariantData.productNumReviews;
			productdetails.productStarRating = tileVariantData.productStarRating;
			productdetails.productOrderType = getProductOrederType();
			productdetails.productVariantID =  tileVariantData.productVariantID || tileVariantData.ID;
			productdetails.productBundle = false;
			productsList.push(productdetails);	
			
		}

	});

	productsList.push({
						"id": pdpdata.masterID,
						"productVariantID": pdpdata.master ? pdpdata.defalutvariant : pdpdata.ID,
						"listType": pageInfo.pageCategory,
						"listName": $(".breadcrumb").find(".breadcrumb-element:eq(1)").first().text().trim(),
						"category": pdpdata.catid,
						"price": pdpdata.pricing ? pdpdata.pricing.sale ? pdpdata.pricing.sale : pdpdata.pricing.minprice ? pdpdata.pricing.minprice : null : null,
						"name": pdpdata.name,
						"brand": getProductBrand(),
						"quantity": Number($(".quantity select").val()),
						"size":  pdpdata.size,
						"subCategory": pdpdata.subcategory,
						"subSubCategory": pdpdata.subsubcategory,
						"productOutOfStock": $(".add-to-cart").data("instock"),
						"productColor": pdpdata.productColor,
						"productType": "Product",
						"collectionName": pdpdata.customBrand,
						"productNumReviews": pdpdata.productNumReviews,
						"productOrderType": getProductOrederType(),
						"productStarRating": pdpdata.productStarRating					
				});
				
	if(productsList.length){
		pushToDataLayer({
		"currencyCode": currencyCode,
		"pageSubCategory": pageInfo.pageSubCategory,
		"event": "addToCart",
		"addToCartType": "Add to Bag - Regimen",
		"pageCategory": pageInfo.pageCategory,
		'products': productsList
	});
	}
	
}

function cartCrossSellafterInit($recommendations) {
	pushToDataLayer({
		"currencyCode": currencyCode,
		"eeAction": "eeListView",
		"event": "eeListView",
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		"products": crosssellProducts($recommendations.find('.slick-slide'), "Einstein", "Cart Page")
	});
}

function cartCrossSellAddToCart($container, e) {
	e.stopPropagation();
	pushToDataLayer({
		"currencyCode": currencyCode,
		"pageSubCategory": pageInfo.pageSubCategory,
		"event": "addToCart",
		"addToCartType": "Add to Bag - Einstein - Cart Page",
		"pageCategory": pageInfo.pageCategory,
		'products': crosssellProducts($container)
	});
}

function quickViewOpenFromCrosssell() {
	pushToDataLayer({
		"event": "open_quickview",
		"productName" : tileVariantData.name? tileVariantData.name : null,
		"productCategory" : tileVariantData.catid? tileVariantData.catid :pageInfo.pageSubCategory ,
		"productSubcategory" : tileVariantData.subcategory? tileVariantData.subcategory : null,
		"productId" : tileVariantData.masterID,
		"pageCategory" : pageInfo.pageCategory,
		"pageSubCategory" : pageInfo.pageSubCategory,
		"productSubsubCategory" : tileVariantData.subsubcategory? tileVariantData.subsubcategory : null
	});
}

function quickViewOpenFromPLPCrosssell(elem) {
	let tileData = elem.closest('.product-tile').find('.gtm-product-tile').data('value');

	pushToDataLayer({
		"event": "open_quickview",
		"productName" : tileData.name? tileData.name : null,
		"productCategory" : tileData.catid? tileData.catid :pageInfo.pageSubCategory,
		"productSubcategory" : tileData.subcategory? tileData.subcategory : null,
		"productId" : tileData.masterID,
		"pageCategory" : pageInfo.pageCategory,
		"pageSubCategory" : pageInfo.pageSubCategory,
		"productSubsubCategory" : tileData.subsubcategory? tileData.subsubcategory : null
	});
}

function trackCollectionClick(elem) {
	const collectionName = elem.find('.range-tile__heading').html().trim();

	pushToDataLayer({
		"event": "browse_collection_page",
		"collectionName" : collectionName
	});
}

function collectionPageCrosssellafterInit() {
	const $container = $(".cross-sell-wrapper .recommendation-container");
    if (!$container.length) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                pushToDataLayer({
                    currencyCode,
					eeAction: "eeListView",
					event: "eeListView",
					pageSubCategory: "Collection Page",
					pageCategory: "Landing Page",
					products: crosssellProducts($container.find(".recommendation-slide"), "Einstein", "Collection Page")
                });
                observer.disconnect();
            }
        });
    }, {
        threshold: 0.3
    });
    observer.observe($container[0]);
}

function collectionPageCrosssellClick() {
	$(".cross-sell-wrapper .recommendation-slide .thumb-link, .cross-sell-wrapper .recommendation-slide .product-link").on("click", function() {
		pushToDataLayer({
			"currencyCode": currencyCode,
			"eeAction": "eeListClick",
			"event": "eeListClick",
			"pageSubCategory": pageInfo.pageSubCategory,
			"pageCategory": pageInfo.pageCategory,
			"products": crosssellProducts($(this).closest('.recommendation-slide'), "Einstein", "Collection Page")
		});
	});
}

export default {
	init: function () {
		initializeGlobalEvents();
	},
	tagmanager: {
		click: function (data) {
			return trackConsultationEvent(data);
		},

		pageview: function (data) {
			return trackConsultationPageview(data);
		}
	},
	gtmInternalPromotion: {
		click: function (data) {
			return trackInternalPromotionEvent(data);
		},

		pageview: function (data) {
			return trackInternalPromotionPageView(data);
		}
	},
	populateSearchSuggestion: function() {
		populateSearchSuggestion();
	},
	trackAccountIconClick: trackAccountIconClick,
	gtmCouponApplied: gtmCouponApplied,
	reinsuranceElements: reinsuranceElements,
	gtmNewsletterPopup: gtmNewsletterPopup,
	googleAddressTracking: googleAddressTracking,
	socialLoginEvent: socialLoginEvent,
	searchOverlayShow : searchOverlayShow,
	searchProductTile : searchProductTile,
	searchCategoryLink : searchCategoryLink,
	searchEinstienProductList: searchEinstienProductList,
	addBonusProductDataLayer: addBonusProductDataLayer,
	cartPaymentDataLayer: cartPaymentDataLayer,
	paypalExpressDatalayer: paypalExpressDatalayer,
	googlePayTracking: googlePayTracking,
	reinsurancePDPDatalayer: reinsurancePDPDatalayer,
	minicartCrossSellProductList: minicartCrossSellProductList,
	minicartCrossSellafterInit: minicartCrossSellafterInit,
	cartCrossSellafterInit: cartCrossSellafterInit,
	cartCrossSellAddToCart: cartCrossSellAddToCart,
	quickViewOpenFromCrosssell: quickViewOpenFromCrosssell,
	quickViewOpenFromPLPCrosssell: quickViewOpenFromPLPCrosssell,
	reinsuranceCheckoutDatalayer: reinsuranceCheckoutDatalayer,
	notifyMeClick: notifyMeClick,
	addProductAIDialog: addProductAIDialog,
	addProductAIDialogPDP: addProductAIDialogPDP,
	sendAIDialogMessage: sendAIDialogMessage,
	minicrosssellPDPonInit: minicrosssellPDPonInit,
	minicrosssellPDPafterInit: minicrosssellPDPafterInit,
	gymsharkCrosssellafterInit: gymsharkCrosssellafterInit,
	pdpRegimenListGtm: pdpRegimenListGtm,
	gtmRegimenQuickView: gtmRegimenQuickView,
	regimenAddToCart: regimenAddToCart,
	trackCartAddition: trackCartAddition,
	refillOfferClick: refillOfferClick,
	reassuranceCheckoutDatalayer: reassuranceCheckoutDatalayer,
	trackSignInDrawerOpen: trackSignInDrawerOpen,
	trackClickCtaAccountModal : trackClickCtaAccountModal,
	trackClickCtaPerksAccountModal :trackClickCtaPerksAccountModal,
	trackCollectionClick: trackCollectionClick,
	collectionPageCrosssellafterInit: collectionPageCrosssellafterInit,
	collectionPageCrosssellClick: collectionPageCrosssellClick
}